<template>
    <div class="verAddCon"  v-if='showModel'>
            
        <div style="padding: 20px;border-bottom: 20px solid #f5f7f9;">
            <div class="title">{{title}}</div>
            <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
        </div>
            
            
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="120" inline>
    
                <!-- 基础信息 -->

                <div style="padding:0px 20px 20px;border-bottom: 20px solid #f5f7f9;">
                    <h2 class="titleMain">{{$t("seceneManage.addModel.module1")}}</h2>

                     <!-- 场景名称 -->
                    <FormItem :label="$t('seceneManage.addModel.sceneModelName')" prop="templateName"  style="min-width: 500px;">
                        <Input type="text" maxlength="128" v-model.trim="formData.templateName" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
    
                     <!-- 场景图片 -->
                    <FormItem :label="$t('seceneManage.addModel.photo')" prop="bgImage" class="imgCon ivu-form-item-required" style="display: flex;align-items: center;">
                        <ImgUpload style="margin-top: 20px;margin-left: -120px;" ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="1"  @setThumbUrl="setThumbUrlthumb"  @removeThumbUrl='removeThumbUrl'></ImgUpload>
                        <span class="simple-size">500x200 dpi</span>
                    </FormItem>

                </div>


                <!-- 触发条件 -->
                <div style="padding:0px 20px 20px;border-bottom: 20px solid #f5f7f9;">
                    <h2  class="titleMain">{{$t("seceneManage.addModel.module2")}}</h2>
                    <div class="tip">{{$t("seceneManage.addModel.triggerTip")}}</div>

                    <div>
                        <div class="noSet"  v-if="!showTrigger">{{$t("seceneManage.addModel.noTrigger")}}</div>

                        <div  v-show="showTrigger">
                                <div  style="max-height:800px;overflow-y:auto">

                                    <div class="flexC moduleItem" style="margin-bottom:10px" v-for="(item,index) in formData.triggerItems" :key="'trigger'+index" :class="item.status!=1?'moduleItemNo':''">

                                        <div style="display:flex;justify-content:flex-start;flex-wrap:wrap;position: relative;width: 100%;"  v-show="item.status">

                                            <!-- 触发条件类型 默认选择第一项，不可清除，不需加rules+++++++++ -->
                                            <FormItem style="width:160px;">
                
                                                <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.triggerType" @on-select="setSelectValPage($event,item.index,'triggerType')" @on-open-change="selectOpenChange($event,'triggerType')">
                                                     <Option v-for="(sitem, sindex) in selectObj.triggerTypeList" :value="sitem.id"  :disabled="sitem.disabled" :key="sindex">{{sitem['val']}}</Option>
                                                 </Select>

                                            </FormItem>
                                            <!-- 触发条件为设备属性时 -->
                                            <template>


                                                <!-- 选择产品型号++++++++++++ -->
                                                <FormItem
                                                     v-show="item.triggerType==1 || item.triggerType==3"
                                                     :prop="'triggerItems.' + index + '.productTypeId'"  
                                                     style="width:230px"
                                                     :rules="{required: ((item.triggerType==1 ||item.triggerType==3)  && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
    
                                                     <SearchSelectRecycle
                                                      :placeholderText="$t('seceneManage.addModel.selectPlaceholder.productType')"  
                                                      :refName="'productTypeIdSelectTrigger'+index"   
                                                      :ref="'productTypeIdSelectTrigger'+index" 
                                                      :selectUrlQuery="{'published':true,'joinSense':true}" 
                                                      :url="getProductList"  
                                                      listName='productList'
                                                      labelName='productType'  
                                                      isMultiple='2'  
                                                      valName='id' 
                                                      keyword="productType" 
                                                      :labelInValue="true"  
                                                      @setSelected="setSelectValPage($event,item.index,'productTypeId')"></SearchSelectRecycle>
                                                      
                         
                                                </FormItem>

                                                <!-- 根据基础型号id获取对应的属性，选择设备属性++++++++++ -->
                                                <FormItem
                                                    v-show="item.triggerType==1 && item.basicId"  
                                                    style="width:230px"
                                                    :prop="'triggerItems.' + index + '.keyId'"
                                                    :rules="{required: (item.triggerType==1 && item.basicId && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
    
                                                    <SearchSelectKeyId
                                                        :placeholderText="$t('seceneManage.addModel.selectPlaceholder.property')"  
                                                        :refName="'keyIdSelectTrigger'+index" 
                                                        :ref="'keyIdSelectTrigger'+index" 
                                                        :selectUrlQuery="{'basicTypeId':item.basicId}" 
                                                        :url="getBasicKeysList" 
                                                        :wordList="wordList"  
                                                        labelName='keyNameText' 
                                                        newField=""  
                                                        isMultiple='2'  
                                                        valName='id'  
                                                        keyword="keyNameText" 
                                                        :labelInValue="true"  
                                                        @setSelected="setSelectValPage($event,item.index,'keyId')"></SearchSelectKeyId>

                                                </FormItem>

                                                <!-- 根据设备属性，conditionJudgment来判断符号范围   默认选择第一项，不可清除，不需加rules-->
                                                <FormItem
                                                   v-show="item.triggerType==1 && item.basicId && item.conditionJudgment==1" 
                                                   style="width:100px">
                    
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.intType" @on-select="setSelectValPage($event,item.index,'intType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.intSelListOne" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                     </Select>
                                                
                                                </FormItem>

                                                <!-- 根据设备属性，conditionJudgment来判断符号范围  默认选择第一项，不可清除，不需加rules -->
                                                <FormItem
                                                    v-show="item.triggerType==1 &&item.conditionJudgment==2" 
                                                    style="width:100px">
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.intType" @on-select="setSelectValPage($event,item.index,'intType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.intSelListTwo" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                     </Select>
                                                
                                                </FormItem>

                                                <!-- formatType 是数值 +++  -->
                                                <FormItem 
                                                     v-show="item.triggerType==1 &&item.basicId && formatNumber.includes(item.formatType)" 
                                                     style="width:150px"
                                                     :prop="'triggerItems.' + index + '.intValue'"
                                                     :rules="{required: item.status===1 && item.basicId && item.keyId && formatNumber.includes(item.formatType)?true:false, type:'number', message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
                                                    
                                                     <InputNumber
                                                       v-if="item.status===1 && item.basicId && item.keyId && formatNumber.includes(item.formatType)"
                                                       :max="(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Max*1 : Infinity"
                                                       :min="(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Min*1 : -Infinity"
                                                       :precision = "(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Decimals'))?item.keyObj.formatContentObj[0]['Decimals']*1:0"
                                                       :active-change="false"
                                                       :value="item.intValue"
                                                       :formatter="value => `${value}${ item.keyObj.formatContentObj? item.keyObj.formatContentObj[0].unitText:''}`"
                                                       :parser="value => value.replace(item.keyObj.formatContentObj? item.keyObj.formatContentObj[0].unitText:'', '')"
                                                        @on-change="setSelectChange($event,item.index,'intValue')"
                                                        :placeholder="((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Min : -Infinity) + '~'+ ((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Max: Infinity)+((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('unitText') )?item.keyObj.formatContentObj[0].unitText: '')"></InputNumber>
                                                
                                                </FormItem>

                                                <!-- formatType 是时间   没处理好，先放一放  -->
                                                <FormItem
                                                     v-show="item.triggerType==1 &&item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj" 
                                                     style="width:170px"
                                                     :prop="'triggerItems.' + index + '.timeValue'"
                                                     :rules="triggerItemsDynamicRules">
                                                     <!-- :rules="{required: (item.triggerType==1 && item.basicId && item.keyId && formatDate.includes(item.formatType) && item.status===1)?true:false, message:'This field cannot be left blank.', trigger: 'change'}"> -->

                                                     <DatePicker
                                                       v-if="item.triggerType==1 &&item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate.includes('YY')  && item.status===1"
                                                       :value="item.timeValue"
                                                       @on-change="setDateChange($event,item,'timeValue')" 
                                                       type="datetime" 
                                                       transfer 
                                                       :editable="false"
                                                       :format="item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate? selectObj.timeFormateList[item.keyObj.formatContentObj[0].formate]:'yyyy-MM-dd HH:mm:ss'" 
                                                       :placeholder="item.dateObj.placeholder" 
                                                       :options="options3"
                                                       style="width: 200px"></DatePicker>

                                                       <TimePicker
                                                       v-if="item.triggerType==1 &&item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj && !item.keyObj.formatContentObj[0].formate.includes('YY')  && item.status===1"
                                                        :value="item.timeValue"  
                                                        @on-change="setDateChange($event,item,'timeValue')" 
                                                        :disabled-hours="item.dateObj.disabledHours"
                                                        :disabled-minutes="item.dateObj.disabledMinutes"
                                                        :disabled-seconds="item.dateObj.disabledSeconds"
                                                        transfer  
                                                        :editable="false"
                                                        :format="item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate? selectObj.timeFormateList[item.keyObj.formatContentObj[0].formate]:'HH:mm:ss'"  
                                                        placement="bottom-end" 
                                                        :placeholder="item.dateObj.placeholder" 
                                                        style="width: 168px"></TimePicker> 
                                                    
                                                     
                                                </FormItem>


                                                <!-- formatType 是数组 +++++  -->

                                                <!-- <FormItem  v-show="item.triggerType==1 &&item.keyId && formatEnum.includes(item.formatType)" style="width:100px"
                                                    :prop="'triggerItems.' + index + '.enumValue'"
                                                    :rules="{required: (item.triggerType==1 && item.basicId && item.keyId && formatEnum.includes(item.formatType) && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    
                                                    <Select
                                                        v-if="item.triggerType==1 &&item.keyId && formatEnum.includes(item.formatType) && item.status===1"
                                                        :placeholder='$t("selectPlaceholder")'  
                                                        transfer 
                                                        class="input-div" 
                                                        :value="item.enumValue" 
                                                        @on-select="setSelectValPage($event,item.index,'enumValue')">
                                                         <Option v-for="(sitem, sindex) in item.keyObj.formatContentObj" :value="sitem.Code" :key="sindex" :label="sitem.nameText" :title="sitem.nameText"></Option>
                                                    </Select>
                                                </FormItem> -->


                                                <!-- formatType 是其他 formatOther-->
                                                <!-- <FormItem 
                                                     v-show="item.triggerType==1 &&item.basicId && formatOther.includes(item.formatType)" 
                                                     style="width:200px"
                                                     :prop="'triggerItems.' + index + '.objValue'"
                                                     :rules="{required: item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType)?true:false, message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
            
                                                    <Input
                                                       v-if="item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType)"
                                                       v-model="item.objValue" :maxlength="formatStr.includes(item.formatType) && item.keyObj.formatContent && !isNaN(parseFloat(item.keyObj.formatContent))&& isFinite(item.keyObj.formatContent) ? item.keyObj.formatContent:Infinity"></Input>
                                                
                                                </FormItem> -->

                                                 <!-- formatType 是数组 +++++  -->
                                                 <FormItem
                                                  v-show="item.triggerType==1 &&item.keyId && formatEnum.includes(item.formatType) && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) " 
                                                  style="width:100px"
                                                    :prop="'triggerItems.' + index + '.enumValue'"
                                                    :rules="{required: (item.triggerType==1 && item.basicId && item.keyId && formatEnum.includes(item.formatType) && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <Select
                                                      v-if="item.triggerType==1 && item.basicId && item.keyId && formatEnum.includes(item.formatType)  && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1"
                                                      :placeholder='$t("selectPlaceholder")'  
                                                      transfer 
                                                      class="input-div" 
                                                      :value="item.enumValue" 
                                                      @on-select="setSelectValPage($event,item.index,'enumValue','triggerItems')">
                                                         <Option v-for="(sitem, sindex) in item.keyObj.formatContentObj" :value="sitem.Code" :key="sindex" :label="sitem.nameText" :title="sitem.nameText"></Option>
                                                    </Select>
                                                </FormItem>

                                                <!-- formatType 11或者4 名称是色彩，单独处理，选颜色， +++++ -->
                                                <FormItem
                                                  v-show="item.triggerType==1 &&item.keyId  && ((item.formatType==4 ||item.formatType==11)  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) " 
                                                  style="width:100px"
                                                    :prop="'triggerItems.' + index + '.colorValue'"
                                                    :rules="{required: (item.triggerType==1 && item.basicId && item.keyId && (
                                                        (item.formatType==4 ||item.formatType==11)  
                                                        && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))
                                                       )  
                                                        && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <ColorPicker
                                                     v-if="item.triggerType==1 && item.basicId && item.keyId && ((item.formatType==4 ||item.formatType==11)   && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1"
                                                     :placeholder='$t("selectPlaceholder")'
                                                     transfer
                                                     :value="item.colorValue"
                                                     @on-change = "setSelectColor($event,item.index,'colorValue','triggerItems')"
                                                      />
                                                    </FormItem>


                                                 <!-- formatType 是其他 formatOther-->
                                                 <FormItem 
                                                     v-show="item.triggerType==1 &&item.basicId && formatOther.includes(item.formatType) && !(item.formatType==4 && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987'))))" 
                                                     style="width:100px"
                                                     :prop="'triggerItems.' + index + '.objValue'"
                                                     :rules2="actionItemsInputRules"
                                                     :rules="{required: item.triggerType==1 && item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType) && !(item.formatType==4 && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) ?true:false, message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
                                                    
                                                    <Input
                                                       v-if="item.triggerType==1 &&item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType)"
                                                        :maxlength="formatStr.includes(item.formatType) && item.keyObj.formatContent && !isNaN(parseFloat(item.keyObj.formatContent))&& isFinite(item.keyObj.formatContent) ? item.keyObj.formatContent:Infinity"
                                                       v-model="item.objValue"></Input>
                                                
                                                </FormItem>












                                                
                                                <!-- 只有设备属性有附加条件 && (item.intValue===0 || item.intValue  || item.timeValue || item.enumValue)-->
                                                <FormItem v-show="item.triggerType==1">
                                                    <Button type="text" v-show="item.basicId && item.keyId"  @click="item.showAddition=false">
                                                        <span style="font-weight: bold;margin-right: 5px;"  :title="$t('seceneManage.addModel.addtionTitle')">{{$t('seceneManage.addModel.addtionBox.addtion')}}</span>
                                                        <Icon type="md-settings" v-show="item.showAddition"  :title="$t('seceneManage.addModel.addtionTitle1')" />
                                                    </Button>

                                                </FormItem>

                                                 <!-- 附加条件类型 -->
                                                 <FormItem  v-show="item.triggerType==1 && item.basicId && !item.showAddition" style="width:140px">
                                                    <Select  transfer class="input-div" :value="item.additionType"  @on-select="setSelectValPage($event,item.index,'additionType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.additionTypeList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                    </Select>
                                                </FormItem>

                                                 <!-- 生效时间和次数 -->
                                                 <FormItem  v-show="item.triggerType==1 && item.basicId && item.additionType==1 && !item.showAddition" style="width:160px">
                                                    <Select  :placeholder="$t('seceneManage.addModel.addtionBox.title')" transfer class="input-div" :value="item.effectiveType" @on-select="setSelectValPage($event,item.index,'effectiveType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.effectiveTypeList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                    </Select>
                                                </FormItem>

                                                 <!-- 部分时段范围 -->
                                                 <FormItem  v-show="item.triggerType==1 && item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType==2" style="width:170px">
                                                    <TimePicker :value="item.partTime" transfer format="HH:mm" type="timerange"  @on-change="setSelectChange($event,item.index,'partTime')" placement="bottom-end" :placeholder="$t('seceneManage.addModel.selectPlaceholder.partTime')"  style="width: 168px"></TimePicker>
                                                </FormItem>


                                            </template>

                                            <!-- 触发条件为定时触发时 -->
                                            <template >
                                                
                                                <!-- 循环方式- 天周月日年指定 默认选择第一项，不可清除，不需加rules -->
                                                <FormItem v-show="(item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2" style="width:100px">
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.repeatType" @on-select="setSelectValPage($event,item.index,'repeatType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.timeRepeatList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                    </Select>

                                                </FormItem>

                                               
                                                <!-- 周循环，选周几，多选 -->
                                                <FormItem
                                                     v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.repeatType==2"
                                                     style="width:270px"
                                                     :prop="'triggerItems.' + index + '.weekVal'"
                                                     :rules="{required: (((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.repeatType==2 && item.status===1)?true:false,type:'array', message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <Select  :placeholder='$t("selectPlaceholder")' multiple   transfer class="input-div" :value="item.weekVal" @on-change="setSelectChange($event,item.index,'weekVal')">
                                                         <Option v-for="(sitem, sindex) in selectObj.weekList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                    </Select>
                                                
                                                </FormItem>
                                                
                                                <!-- 月份循环，选几号，单选，数字 -->
                                                <FormItem 
                                                    v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.repeatType==3"
                                                     style="width:100px"
                                                     :prop="'triggerItems.' + index + '.monthVal'"
                                                     :rules="{required: (((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==3) && item.repeatType==3 && item.status===1)?true:false,type:'number', message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                    
                                                    <Select  :placeholder='$t("selectPlaceholder")' transfer class="input-div" :value="item.monthVal" @on-select="setSelectValPage($event,item.index,'monthVal')">
                                                         <Option v-for="sitem in monthArr" :value="sitem" :key="sitem">{{sitem}}</Option>
                                                    </Select>
                                                
                                                </FormItem>

                                               <!-- 年份，选择几月几号，单选 ，数组 -->
                                                <FormItem
                                                     v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.repeatType==4"
                                                     style="width:100px"
                                                     :prop="'triggerItems.' + index + '.yearVal'"
                                                     :rules="{required: (((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==4) && item.repeatType==4 && item.status===1)?true:false,type:'array', message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <Cascader :data="monthsAndDaysArr" transfer :value="item.yearVal" @on-change="setSelectChange($event,item.index,'yearVal')"></Cascader>
                                                </FormItem>
                                                
                                                <!-- 指定日期 ，单选，字符串-->
                                                <FormItem
                                                    v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.repeatType==5"
                                                     style="width:130px"
                                                     :prop="'triggerItems.' + index + '.dateVal'"
                                                     :rules="{required: (((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==5) && item.repeatType==5 && item.status===1)?true:false,type:'string', message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <DatePicker
                                                        type="date" 
                                                        :options="options3" 
                                                        transfer 
                                                        :value="item.dateVal" 
                                                        :placeholder="$t('seceneManage.addModel.selectPlaceholder.onceDate')"
                                                        :editable="false"
                                                        @on-change="setDateChange($event,item,'dateVal')" 
                                                        style="width: 130px"></DatePicker>
                                                </FormItem>


                                                <!-- 触发条件是定时触发时，时间需大于当前时间 -->
                                                <FormItem v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.triggerType==2" style="width:120px">
                                                    <TimePicker
                                                       :value="item.specialTime" 
                                                       format="HH:mm" 
                                                       :disabledHours="(item.repeatType==5 && item.dateVal && item.dateVal==currentYear+'-'+currentMonth+'-'+currentDay)?disabledHours:[]" 
                                                       :disabledMinutes="(item.repeatType==5 && item.dateVal && item.dateVal==currentYear+'-'+currentMonth+'-'+currentDay)?disabledMinutes:[]"  
                                                       transfer 
                                                       placeholder="hh:mm"
                                                        style="width: 112px" 
                                                        @on-change="setSelectChange($event,item.index,'specialTime')"></TimePicker>
                                                </FormItem>
                                                

                                                <!-- 删除附加条件 -->
                                                <FormItem  v-show="((item.basicId && item.additionType==1 && !item.showAddition && item.effectiveType )|| item.triggerType==2) && item.basicId && item.keyId">
                                                    <i v-if="!item.showAddition"  @click="delAdditionalCondition(item.index)" :title="$t('seceneManage.addModel.addtionTitle2')" class="iconfont icon-shanchu ivu-icon ivu-icon-ios-settings ivu-btn-text" style="font-size: 14px;cursor: pointer;"></i>
                                                </FormItem>

                                            </template>

                                            <!-- 触发条件为天气时 -->
                                            <template>
                                                <!-- 选择天气列表 默认选择第一项，不可清除，不需加rules -->
                                                <FormItem v-show="item.triggerType==3 && item.basicId" style="width:100px">
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.weatherType" @on-select="setSelectValPage($event,item.index,'weatherType')">
                                                         <Option v-for="(sitem, sindex) in selectObj.weatherList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                    </Select>

                                                </FormItem>
                                             

                                            </template>

                                            <!-- 排序 -->
                                           <!-- <FormItem style="width:160px;">
                                                <div class="flexC">
                                                    <h4 style="flex-shrink: 0;margin-right: 10px;">{{$t('BasicProduct.funcBox.titleName.Order')}}</h4>
                                                    <InputNumber
                                                        :min="0"
                                                        :precision = "0"
                                                        :active-change="false"
                                                        :value="item.sortNumber"
                                                         @on-change="setSelectChange($event,item.index,'sortNumber')"></InputNumber>
                                                </div>

                                            </FormItem> -->



                                            <FormItem  class="delButton">
                                               <Button type="error" size="small"style="font-size: 12px;" :disabled="enumTriggerDelDisabled"  @click="handleRemove(index,'trigger')">{{$t("delete")}}</Button>
                                            </FormItem>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                </div>
                                <div type="text" style="color: #2d8cf0;cursor: pointer;"  @click="handleAddItem('trigger')">
                                    + {{$t("seceneManage.addModel.addTrigger")}}
                                </div>
                        </div>
                        
                    </div>

                </div>


                <!-- 执行动作 -->
                <div style="padding:0px 20px 20px;border-bottom: 20px solid #f5f7f9;">
                    <h2  class="titleMain">{{$t("seceneManage.addModel.module3")}}</h2>

                    <div>
                        <div class="noSet"  v-if="!showAction">{{$t("seceneManage.addModel.noAction")}}</div>
                        <div>
                            <div  style="max-height:800px;overflow-y:auto">
                                    <div class="flexC moduleItem" style="margin-bottom:10px" v-for="(item,index) in formData.actionItems" :key="'action'+index" :class="item.status!=1?'moduleItemNo':''">

                                        <div style="display:flex;justify-content:flex-start;flex-wrap:wrap;position: relative;width: 100%;"  v-show="item.status">

                                            <!-- 任务类型 -->
                                            
                                            <FormItem style="width:160px">
                                                <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.actionType" @on-select="setSelectValPage($event,item.index,'actionType','actionItems')">
                                                     <Option v-for="(sitem, sindex) in selectObj.actionTypeList" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                 </Select>
                                            
                                            </FormItem>

                                            
                                            <!-- 选择系统功能后 -->

                                            <template>

                                                <!-- 系统功能对应的列表 -->
                                                <FormItem  v-show="item.actionType==1" style="width:160px">
                    
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.systemFunctionType" @on-select="setSelectValPage($event,item.index,'systemFunctionType','actionItems')">
                                                         <Option v-for="(item, index) in selectObj.systemFunctionList" :value="item.id" :key="index">{{item['val']}}</Option>
                                                     </Select>
                                                </FormItem>

                                                <!-- 消息提醒对应列表 -->
                                                <FormItem  v-show="item.actionType==1 && item.systemFunctionType==1" style="width:160px">
                    
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.messageReminderType" @on-select="setSelectValPage($event,item.index,'messageReminderType','actionItems')">
                                                         <Option v-for="(item, index) in selectObj.messageReminderList" :value="item.id" :key="index">{{item['val']}}</Option>
                                                     </Select>
                                                </FormItem>

                                                <!-- 编辑发送通知的内容 -->
                                                <FormItem
                                                     v-show="item.actionType==1 && item.systemFunctionType==1 && item.messageReminderType==1" 
                                                     style="width:360px"
                                                     :prop="'actionItems.' + index + '.notificationVal'"
                                                     :rules="{required:(item.actionType==1 && item.systemFunctionType==1 && item.messageReminderType==1 && item.status===1)?true:false, message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
                                                    
                                                     <Input type="textarea" maxlength="256" v-model="item.notificationVal" :placeholder="$t('seceneManage.addModel.editNotification')"></Input>
                                              
                                                </FormItem>
                                            </template>

                                             <!-- 选择智能设备后 item.actionType==3 -->
                                            <template>

                                                <!-- 选择产品型号++++++++++++ -->
                                                <FormItem
                                                     v-show="item.actionType==3"
                                                     :prop="'actionItems.' + index + '.productTypeId'"  
                                                     style="width:230px"
                                                     :rules="{required: (item.actionType==3 && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
    
                                                     <SearchSelectRecycle
                                                      :placeholderText="$t('seceneManage.addModel.selectPlaceholder.productType')"  
                                                      :refName="'productTypeIdSelectAction'+index"   
                                                      :ref="'productTypeIdSelectAction'+index" 
                                                      :selectUrlQuery="{'published':true,'joinSense':true}" 
                                                      :url="getProductList"  
                                                      listName='productList'
                                                      labelName='productType'  
                                                      isMultiple='2'  
                                                      valName='id' 
                                                      keyword="productType" 
                                                      :labelInValue="true"  
                                                      @setSelected="setSelectValPage($event,item.index,'productTypeId','actionItems')"></SearchSelectRecycle>
                         
                                                </FormItem>


                                                <!-- 根据基础型号id获取对应的属性，选择设备属性++++++++++ -->
                                                <FormItem
                                                    v-show="item.actionType==3 && item.basicId"  
                                                    style="width:230px"
                                                    :prop="'actionItems.' + index + '.keyId'"
                                                    :rules="{required: (item.actionType==3 && item.basicId && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
    
                                                    <SearchSelectKeyId
                                                        :placeholderText="$t('seceneManage.addModel.selectPlaceholder.property')"  
                                                        :refName="'keyIdSelectAction'+index" 
                                                        :ref="'keyIdSelectAction'+index" 
                                                        :selectUrlQuery="{'basicTypeId':item.basicId,'type':'action'}" 
                                                        :url="getBasicKeysList" 
                                                        :wordList="wordList"  
                                                        labelName='keyNameText' 
                                                        newField=""  
                                                        isMultiple='2'  
                                                        valName='id'  
                                                        keyword="keyNameText" 
                                                        :labelInValue="true"  
                                                        @setSelected="setSelectValPage($event,item.index,'keyId','actionItems')"></SearchSelectKeyId>

                                                </FormItem>

                                                <!-- 根据设备属性，conditionJudgment来判断符号范围   默认选择第一项，不可清除，不需加rules-->
                                                <!-- <FormItem  v-show="item.actionType==3 && item.basicId && item.conditionJudgment==1 " style="width:100px">
                    
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.intType" @on-select="setSelectValPage($event,item.index,'intType','actionItems')">
                                                         <Option v-for="(sitem, sindex) in selectObj.intSelListOne" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                     </Select>
                                                
                                                </FormItem> -->

                                                <!-- 根据设备属性，conditionJudgment来判断符号范围  默认选择第一项，不可清除，不需加rules -->
                                                <!-- <FormItem  v-show="item.actionType==3 &&item.conditionJudgment==2 " style="width:100px">
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.intType" @on-select="setSelectValPage($event,item.index,'intType','actionItems')">
                                                         <Option v-for="(sitem, sindex) in selectObj.intSelListTwo" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                     </Select>
                                                
                                                </FormItem> -->

                                                 <!-- 执行 只有 = ，conditionJudgment为1或者2都只显示= -->
                                                 <FormItem  v-show="item.actionType==3 && (item.conditionJudgment==2 || item.conditionJudgment==1) " style="width:100px">
                                                    <Select  :placeholder='$t("selectPlaceholder")'  transfer class="input-div" :value="item.intType" @on-select="setSelectValPage($event,item.index,'intType','actionItems')">
                                                         <Option v-for="(sitem, sindex) in selectObj.intSelListTwo" :value="sitem.id" :key="sindex">{{sitem['val']}}</Option>
                                                     </Select>
                                                
                                                </FormItem>


                                                <!-- formatType 是数值 +++  -->
                                                <FormItem 
                                                     v-show="item.actionType==3 && item.basicId && formatNumber.includes(item.formatType)" 
                                                     style="width:100px"
                                                     :prop="'actionItems.' + index + '.intValue'"
                                                     :rules="{required: item.status===1 && item.basicId && item.keyId && formatNumber.includes(item.formatType)?true:false, type:'number', message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
            
                                                    <InputNumber
                                                       v-if="item.actionType==3 && item.status===1 && item.basicId && item.keyId && formatNumber.includes(item.formatType)"
                                                       :max="(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Max*1 : Infinity"
                                                       :min="(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Min*1 : -Infinity"
                                                       :precision = "(item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Decimals'))?item.keyObj.formatContentObj[0]['Decimals']*1:0"
                                                       :active-change="false"
                                                       :value="item.intValue"
                                                       :formatter="value => `${value}${ item.keyObj.formatContentObj? item.keyObj.formatContentObj[0].unitText:''}`"
                                                       :parser="value => value.replace(item.keyObj.formatContentObj? item.keyObj.formatContentObj[0].unitText:'', '')"
                                                        @on-change="setSelectChange($event,item.index,'intValue','actionItems')"
                                                        :placeholder="((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Min : -Infinity) + '~'+ ((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('Max') )?item.keyObj.formatContentObj[0].Max: Infinity)+((item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].hasOwnProperty('unitText') )?item.keyObj.formatContentObj[0].unitText: '')"></InputNumber>
                                                
                                                </FormItem>

                                                <!-- formatType 是时间   没处理好，先放一放  -->
                                                <FormItem
                                                     v-show="item.actionType==3 && item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj" 
                                                     style="width:170px"
                                                     :prop="'actionItems.' + index + '.timeValue'"
                                                     :rules="actionItemsDynamicRules">
                                                     <!-- :rules="{required: (item.triggerType==1 && item.basicId && item.keyId && formatDate.includes(item.formatType) && item.status===1)?true:false, message:'This field cannot be left blank.', trigger: 'change'}"> -->

                                        
                                                     <DatePicker
                                                       v-if="item.actionType==3 &&item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate.includes('YY')  && item.status===1"
                                                       :value="item.timeValue"
                                                       @on-change="setDateChange($event,item,'timeValue','actionItems')" 
                                                       type="datetime" 
                                                       transfer 
                                                       :editable="false"
                                                       :format="item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate? selectObj.timeFormateList[item.keyObj.formatContentObj[0].formate]:'yyyy-MM-dd HH:mm:ss'" 
                                                       :placeholder="item.dateObj.placeholder" 
                                                       :options="options3"
                                                       style="width: 200px"></DatePicker>

                                                       <TimePicker
                                                       v-if="item.actionType==3 &&item.keyId && formatDate.includes(item.formatType) && item.keyObj.formatContentObj && !item.keyObj.formatContentObj[0].formate.includes('YY')  && item.status===1"
                                                        :value="item.timeValue"  
                                                        @on-change="setDateChange($event,item,'timeValue','actionItems')" 
                                                        :disabled-hours="item.dateObj.disabledHours"
                                                        :disabled-minutes="item.dateObj.disabledMinutes"
                                                        :disabled-seconds="item.dateObj.disabledSeconds"
                                                        transfer  
                                                        :editable="false"
                                                        :format="item.keyObj.formatContentObj && item.keyObj.formatContentObj[0].formate? selectObj.timeFormateList[item.keyObj.formatContentObj[0].formate]:'HH:mm:ss'"  
                                                        placement="bottom-end" 
                                                        :placeholder="item.dateObj.placeholder" 
                                                        style="width: 168px"></TimePicker> 
                                                    
                                                     
                                                </FormItem>


                                                <!-- formatType 是数组 +++++  -->
                                                <FormItem
                                                  v-show="item.actionType==3 &&item.keyId && formatEnum.includes(item.formatType) && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) " 
                                                  style="width:100px"
                                                    :prop="'actionItems.' + index + '.enumValue'"
                                                    :rules="{required: (item.actionType==3 && item.basicId && item.keyId && formatEnum.includes(item.formatType) && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <Select
                                                      v-if="item.actionType==3 && item.basicId && item.keyId && formatEnum.includes(item.formatType)  && !(item.formatType==11  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1"
                                                      :placeholder='$t("selectPlaceholder")'  
                                                      transfer 
                                                      class="input-div" 
                                                      :value="item.enumValue" 
                                                      @on-select="setSelectValPage($event,item.index,'enumValue','actionItems')">
                                                         <Option v-for="(sitem, sindex) in item.keyObj.formatContentObj" :value="sitem.Code" :key="sindex" :label="sitem.nameText" :title="sitem.nameText"></Option>
                                                    </Select>
                                                </FormItem>

                                                <!-- formatType 11或者4 名称是色彩，单独处理，选颜色， +++++ -->
                                                <FormItem
                                                  v-show="item.actionType==3 &&item.keyId  && ((item.formatType==4 ||item.formatType==11)  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) " 
                                                  style="width:100px"
                                                    :prop="'actionItems.' + index + '.colorValue'"
                                                    :rules="{required: (item.actionType==3 && item.basicId && item.keyId && (
                                                        (item.formatType==4 ||item.formatType==11)  
                                                        && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))
                                                       )  
                                                        && item.status===1)?true:false, message: $t('seceneManage.addModel.noBlank'), trigger: 'change'}">
                                                    <ColorPicker
                                                     v-if="item.actionType==3 && item.basicId && item.keyId && ((item.formatType==4 ||item.formatType==11)   && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) && item.status===1"
                                                     :placeholder='$t("selectPlaceholder")'
                                                     transfer
                                                     :value="item.colorValue"
                                                     @on-change = "setSelectColor($event,item.index,'colorValue','actionItems')"
                                                      />
                                                    </FormItem>


                                                 <!-- formatType 是其他 formatOther-->
                                                 <FormItem 
                                                     v-show="item.actionType==3 &&item.basicId && formatOther.includes(item.formatType) && !(item.formatType==4 && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987'))))" 
                                                     style="width:100px"
                                                     :prop="'actionItems.' + index + '.objValue'"
                                                     :rules2="actionItemsInputRules"
                                                     :rules="{required: item.actionType==3 && item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType) && !(item.formatType==4 && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))) ?true:false, message:$t('seceneManage.addModel.noBlank'), trigger: 'blur'}">
                                                    
                                                    <Input
                                                       v-if="item.actionType==3 && item.status===1 && item.basicId && item.keyId && formatOther.includes(item.formatType)"
                                                        :maxlength="formatStr.includes(item.formatType) && item.keyObj.formatContent && !isNaN(parseFloat(item.keyObj.formatContent))&& isFinite(item.keyObj.formatContent) ? item.keyObj.formatContent:Infinity"
                                                       v-model="item.objValue"></Input>
                                                
                                                </FormItem>

                                            </template>
                                            
                                        
                                            <!-- 是否默认选中 -->
                                            <!-- <FormItem style="width:90px">
                                                <div class="flexC">
                                                    <h4 style="flex-shrink: 0;margin-right: 10px;">{{$t("seceneManage.addModel.selected")}}</h4>
                                                    <Checkbox v-model="item.selected"></Checkbox>
                                                </div>
                                            
                                            </FormItem> -->

                                             <!-- 延迟执行时间 -->
                                             <FormItem style="width:180px">
                                                <div class="flexC">
                                                    <h4 style="flex-shrink: 0;margin-right: 10px;">{{$t("seceneManage.addModel.delayExecution")}}</h4>
                                                    <InputNumber
                                                        :min="0"
                                                        :precision = "0"
                                                        :active-change="false"
                                                        :formatter="value => `${value}s`"
                                                        :parser="value => value.replace('s', '')"
                                                        :value="item.delaySeconds"
                                                         @on-change="setSelectChange($event,item.index,'delaySeconds','actionItems')"></InputNumber>
                                                </div>
                                            
                                            </FormItem>

                                              <!-- 排序 -->
                                           <!-- <FormItem style="width:160px;">
                                                <div class="flexC">
                                                    <h4 style="flex-shrink: 0;margin-right: 10px;">{{$t('BasicProduct.funcBox.titleName.Order')}}</h4>
                                                    <InputNumber
                                                        :min="0"
                                                        :precision = "0"
                                                        :active-change="false"
                                                        :value="item.sortNumber"
                                                         @on-change="setSelectChange($event,item.index,'sortNumber','actionItems')"></InputNumber>
                                                </div>

                                            </FormItem> -->


                                             
                                            <FormItem  class="delButton">
                                               <Button type="error" size="small" style="font-size: 12px;" :disabled="enumActionDelDisabled"  @click="handleRemove(index,'action')">{{$t("delete")}}</Button>
                                            </FormItem>
                                        </div>
                                    </div>
                            </div>
                            <div class="addBut" style="color: #2d8cf0;cursor: pointer;"  @click="handleAddItem('action')">+ {{$t("seceneManage.addModel.addAction")}}</div>
                        </div>
                    </div>

                </div>

                <FormItem style="width:100%">
                    <div style="margin: 30px 0px 10px -120px;text-align: center">
                        <Button :loading="disabled" :title="$t('seceneManage.addModel.submitTip')"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                        <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                    </div>
                </FormItem>
              
            </Form>

    
    
             
    </div>
    
    </template>
    <script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import moment from 'moment';
    import ImgUpload from "@/views/common/upload";
    import { mapState } from 'vuex'
    import SearchSelect from '../../common/selectList.vue';  //20220415
    import SearchSelectRecycle from './selectListProduct.vue';  //20220415
    import SearchSelectKeyId from './selectListKeyId.vue';  //20220415
    import AddtionalConditions from './addtionalConditionModel.vue';  //20220415
    
   
    import {toTree} from "@/libs/tools.js"
    
    
        export default {
            props: {
                showModel: Boolean,
                fn:Function,
                type:Number,
                editFormData:Object,
                // basicClassIdList:Array,
                // basicClassIdList1:Array
            },
            name: "Model3",
            components: {
                ImgUpload,
                SearchSelect,
                SearchSelectRecycle,
                SearchSelectKeyId,
                AddtionalConditions
            },
            data() {
                return {   
                    getBasicProductsList: this.config.urlArray.typeList,//获取基础型号列表
                    getBasicKeysList: this.config.urlArray.getBasicKeys,//根据基础型号id获取对应的属性
                    getProductList:this.config.urlArray.productsManageList,//获取产品型号列表
                    uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口

                    // pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                    // getBasicKeysUrl:this.config.urlArray.getBasicKeys,//获取一个基础型号对应的键，或者的所有键
                    hasUpload: [], //已上传图片
                    disabled: false,//禁用确定按钮
                    // title: '',//弹框标题
                    wordList:[],
                    formatNumber: [1,7,14,15,16],
                    formatEnum: [2,3,8,9,11,17],
                    // formatObj : [13],
                    formatDate: [6,12,-1],
                    formatOther:[4,10,13],
                    formatStr:[4,10],
                    formatHex:[7,8,9,10,11,12,14],
                    list:[1,2,3,4,5],
                    formData: {//表单数据
                        id:null,//id是创建场景模型成功,数据库返回的id
                        templateName:'',
                        // bgImage:'',//基础型号对应的上传的图片编号
                        bgImage:'',//基础型号对应的上传的图片编号
                        triggerItems: [
                            {   
                               id:null,//id是创建场景模型成功,数据库返回的id
                               triggerType:1,//触发条件
                               productTypeId:null,//产品型号id
                               productTypeName:'',//产品型号名称,没有deviceWordCode,只有一个名称
                               wordList:[],//多语言列表
                               basicId:null, //基础型号id
                               keyId:null,//设备属性id
                               keyObj:{},//设备属性对应的对象
                               conditionJudgment:0,//基础功能对应的符号,符号是 = 还是<>=
                               formatType:null,//格式
                               intType:1,//符号是 < > =
                               intValue:null,//number类型的值
                               timeValue:'',//时间类型的值
                               enumValue:null,//数组类型的值
                               objValue:null,//其他类型的值
                               colorValue:'',//色彩的值
                               dateObj:{},// 值为时间类型时计算不能选的时分秒列表
                               showAddition:true,//是否显示附加条件那些item,为false的时候有附件条件
                               additionType:1,//附加条件类型
                               repeatType:1,//重复次数类型
                               specialTime:'00:00',//触发条件是定时触发时，选的时间
                               weekVal:[],//重复次数类型时是周循环时选的值
                               monthVal:1,//重复次数类型时是月循环时选的值
                               yearVal:[],//重复次数类型时是年循环时选的值
                               dateVal:'',//重复次数类型时是指定日期循环时选的值
                               effectiveType:1,//生效时间类型，默认是全天生效 
                               partTime:['07:00','08:00'],//生效时间类型为部分时间段时，时间段是值
                               sortNumber:1,//排序
                               weatherType:1,//天气，默认是全部
                               index: 1,
                               status: 1
                            }
                        ],
                        actionItems:[
                            { 
                                id:null,//id是创建场景模型成功,数据库返回的id
                                actionType:1,//执行任务类型
                                systemFunctionType:1,//选择系统功能后对应的列表
                                messageReminderType:1,//选择消息提醒后对应的列表
                                notificationVal:'',//发送消息对应的消息内容
                                delaySeconds:0,//延迟时间，单位s
                                productTypeId:null,//产品型号id
                                productTypeName:'',//产品型号名称
                                wordList:[],//多语言列表
                                basicId:null, //基础型号id
                                keyId:null,//设备属性id
                                keyObj:{},//设备属性对应的对象
                                conditionJudgment:0,//基础功能对应的符号
                                formatType:null,//格式
                                intType:1,//符号是 = 还是<>=
                                intValue:null,//number类型的值
                                timeValue:'',//时间类型的值
                                enumValue:null,//数组类型的值
                                objValue:null,//其他类型的值
                                colorValue:'',//色彩的值
                                dateObj:{},// 值为时间类型时计算不能选的时分秒列表
                                selected:true, //是否默认选中
                                sortNumber:1,//排序
                                index: 1,
                                status: 1
                            }
                        ],
                    },
                    triggerIndex: 1,
                    actionIndex: 1,
                    monthArr:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                    months:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                    monthsAndDaysArr:[],
                    showTrigger:'false',
                    showAction:'false',
                    currentMonth:1,
                    currentDay:1,
                    currentYear:1,
                    options3: {
                        disabledDate (date) {
                            return date && date.valueOf() < Date.now() - 86400000;
                        }
                    },
                    enumTriggerDelDisabled:true,
                    enumActionDelDisabled:true,
                    addtionBox: {
                      //规格弹框组-新增编辑
                      showModel: false, //弹框开关
                      callbackFn: () => {}, //弹框的回调函数
                      editFormData: {}, //编辑时传入的现有数据
                    },
                    triggerInitdata:{
                        id:null,
                        triggerType:1,
                        productTypeId:null,
                        productTypeName:'',
                        wordList:[],
                        basicId:null,
                        keyId:null,
                        keyObj:{},
                        conditionJudgment:0,
                        formatType:null,
                        intType:1,
                        intValue:null,
                        timeValue:'',
                        dateObj:{},
                        enumValue:null,
                        objValue:null,
                        colorValue:'',//色彩的值
                        showAddition:true,
                        additionType:1,
                        repeatType:1,
                        specialTime:'00:00',
                        weekVal:[],
                        monthVal:1,
                        yearVal:[],
                        dateVal:'',
                        effectiveType:1,
                        weatherType:1,
                        partTime:['07:00','08:00'],
                        sortNumber:1,
                        index: 1,
                        status: 1
                    },
                    actionInitdata:{
                        id:null,
                        actionType:1,
                        systemFunctionType:1,
                        messageReminderType:1,
                        notificationVal:'',
                        delaySeconds:0,
                        productTypeId:null,
                        productTypeName:'',
                        wordList:[],
                        basicId:null,
                        keyId:null,
                        keyObj:{},
                        conditionJudgment:0,
                        formatType:null,
                        intType:1,
                        intValue:null,
                        timeValue:'',
                        objValue:null,
                        colorValue:'',//色彩的值
                        enumValue:null,
                        dateObj:{},
                        selected:true,
                        sortNumber:1,
                        index: 1,
                        status: 1
                    },
                    disabledHours:[],
                    disabledMinutes:[],
                }
            },
           
            computed:{
                 ...mapState(['local','selectId']),
                title(){
                    let title = this.type == 1?this.$t('seceneManage.addModel.title'):this.$t('seceneManage.addModel.title1')
                    return title
                },
                ruleCustom(){
                    return {
                        templateName: [
                            {required: true, message: this.$t('required'),trigger: 'blur' },
                        ],
                        bgImage: [
                            {required: true, message: this.$t('required'),trigger: 'change' },
                        ]
                    }
                },
                triggerItemsDynamicRules(){
                    return [
                      {
                        validator: this.triggerItemsValidateCheckMax,
                        trigger: 'change',
                        type:'string'
                      }
                    ]
                },
                actionItemsDynamicRules(){
                    return [
                      {
                        validator: this.actionItemsValidateCheckMax,
                        trigger: 'change',
                        type:'string'
                      }
                    ]
                },
                triggerItemsInputRules(){
                    return [
                      {
                        validator: this.triggerItemsInputCheck,
                        trigger: 'blur',
                        type:'string'
                      }
                    ]
                },
                actionItemsInputRules(){
                    return [
                      {
                        validator: this.actionItemsInputCheck,
                        trigger: 'blur',
                        type:'string'
                      }
                    ]
                },
                selectObj(){
                    return {
                        triggerTypeList:[//触发条件  1.设备属性，2.定时，3.天气 4.手动点击
                            {id: 1,val:this.$t('seceneManage.addModel.triggerTypeSelList.select1'),disabled:false},
                            {id: 2,val:this.$t('seceneManage.addModel.triggerTypeSelList.select2'),disabled:false},
                            // {id: 3,val:this.$t('seceneManage.addModel.triggerTypeSelList.selectWeather'),disabled:false},
                            // {id: 4,val:this.$t('seceneManage.addModel.triggerTypeSelList.select4'),disabled:false}
                        ],
                        weatherList:[
                            {id: 1,val:this.$t('seceneManage.addModel.weatherList.selectAll')},
                            {id: 2,val:this.$t('seceneManage.addModel.weatherList.select1')},
                            {id: 3,val:this.$t('seceneManage.addModel.weatherList.select2')},
                            {id: 4,val:this.$t('seceneManage.addModel.weatherList.select3')},
                            {id: 5,val:this.$t('seceneManage.addModel.weatherList.select4')},
                        ],
                        intSelListOne:[//符号列表 = > <
                            {id: 1,val:this.$t('seceneManage.addModel.intSelList.select1')},
                            {id: 2,val:this.$t('seceneManage.addModel.intSelList.select2')},
                            {id: 3,val:this.$t('seceneManage.addModel.intSelList.select3')},
                            // {id: 4,val:this.$t('seceneManage.addModel.intSelList.select4')},
                            // {id: 5,val:this.$t('seceneManage.addModel.intSelList.select5')},
                        ],
                        intSelListTwo:[//符号列表 = 
                            {id: 1,val:this.$t('seceneManage.addModel.intSelList.select1')},
                        ],
                        timeRepeatList:[// 循环 天周月日年指定
                            {id: 1,val:this.$t('seceneManage.addModel.timerSelList.select3')},
                            {id: 2,val:this.$t('seceneManage.addModel.timerSelList.select4')},
                            {id: 3,val:this.$t('seceneManage.addModel.timerSelList.select5')},
                            {id: 4,val:this.$t('seceneManage.addModel.timerSelList.select6')},
                            {id: 5,val:this.$t('seceneManage.addModel.timerSelList.select7')},
                        ],
                        weekList:[// 周一到周日
                            {id: 1,val:this.$t('seceneManage.addModel.timerScheduleSelList.select7')},
                            {id: 2,val:this.$t('seceneManage.addModel.timerScheduleSelList.select1')},
                            {id: 3,val:this.$t('seceneManage.addModel.timerScheduleSelList.select2')},
                            {id: 4,val:this.$t('seceneManage.addModel.timerScheduleSelList.select3')},
                            {id: 5,val:this.$t('seceneManage.addModel.timerScheduleSelList.select4')},
                            {id: 6,val:this.$t('seceneManage.addModel.timerScheduleSelList.select5')},
                            {id: 7,val:this.$t('seceneManage.addModel.timerScheduleSelList.select6')},
                        ],
                        additionTypeList:[// 附加条件 1.生效时间和次数
                            {id: 1,val:this.$t('seceneManage.addModel.addtionBox.title')}
                        ],
                        effectiveTypeList:[// 生效时间和次数对应的循环类型 1.全天2.不分时间段
                            {id: 1,val:this.$t('seceneManage.addModel.addtionBox.all')},
                            {id: 2,val:this.$t('seceneManage.addModel.addtionBox.partTime')},
                        ],

                        actionTypeList:[//执行动作
                            {id: 1,val:this.$t('seceneManage.addModel.actionTypeSelList.select5')},
                            // {id: 2,val:this.$t('seceneManage.addModel.actionTypeSelList.select6')},
                            {id: 3,val:this.$t('seceneManage.addModel.actionTypeSelList.select7')},
                        ],
                        systemFunctionList:[//系统功能对应列表
                            {id: 1,val:this.$t('seceneManage.addModel.systemFunctionList.select1')}
                        ],
                        messageReminderList:[
                            {id: 1,val:this.$t('seceneManage.addModel.actionTypeSelList.select2')}
                        ],
                        timeFormateList:{
                           'YYYY-MM-DD':"yyyy-MM-dd",
                           'YYYY-MM-DD HH-MM-SS':"yyyy-MM-dd HH:mm:ss",
                           'HH-MM-SS':"HH:mm:ss",
                           'HH-MM':"HH:mm:ss",//显示的是时分秒，因为组件不能标标头，容易弄混
                           'MM-SS':"mm:ss",
                           'MM-SS-MS':"mm:ss.SSS",
                           'SS-MS':"ss.SSS"
                        },
                        timeFormateList2:{
                           'YYYY-MM-DD':"yyyy-MM-dd",
                           'YYYY-MM-DD HH-MM-SS':"yyyy-MM-dd HH:mm:ss",
                           'HH-MM-SS':"HH:mm:ss",
                           'HH-MM':"HH:mm:ss",//显示的是时分秒，因为组件不能标标头，容易弄混
                           'MM-SS':"mm:ss",//显示的是时分
                           'MM-SS-MS':"mm:ss.SSS",
                           'SS-MS':"ss.SSS"
                        },
                        timeFormateList1:[
                          {id: 'YYYY-MM-DD',val:"yyyy-MM-dd"},
                          {id: 'YYYY-MM-DD HH-MM-SS',val:"yyyy-MM-dd HH:mm:ss"},
                          {id: 'HH-MM-SS',val:"HH:mm:ss"},
                          {id: 'HH-MM',val:"HH:mm:ss"},//显示的是时分秒，因为组件不能标标头，容易弄混
                          {id: 'MM-SS',val:"mm:ss"},
                          {id: 'MM-SS-MS',val:"mm:ss.SSS"},
                          {id: 'SS-MS',val:"ss.SSS"},
                        ],
                      
                    }
                },
    
            },
            created(){
            },
            mounted(){

            },
            watch:{
                async showModel(val){
                    if(val === true) { 
                        this.getDays()
                       
                        if(this.type == 1){
                            this.$nextTick(()=>{
                                this.$refs['productTypeIdSelectTrigger0'][0].getData()
                            })
                            this.triggerIndex = 1
                            this.actionIndex = 1
                            this['enumTriggerDelDisabled'] = true
                            this['enumActionDelDisabled'] = true
                            this.formData.triggerItems = common.deepClone( [{...this.triggerInitdata}])
                            this.formData.actionItems = common.deepClone( [{...this.actionInitdata}])
                        }
    
                        if(this.type==2){
                            
                            // 表单字段赋值
                            for (let key in this.editFormData) {
                                if (this.formData.hasOwnProperty(key)) {
                                    this.formData[key] = this.editFormData[key]
                                }
                            }

                            
                            //图片赋值
                            this.$nextTick(()=>{
                                let hasUpload = [{status:'finished', response:{data:this.formData.bgImage}}]
                                this.$refs.upLogoImg.setHasUpload(hasUpload)
                            }); 



                            let dataArr = this.editFormData.sceneTemplateContents

                            let triggerItemsDataArr = []
                            let actionItemsDataArr = []
                            let triggerItemsDataArr1 = []
                            let actionItemsDataArr1 = []
                            let triggerConditionTaskType = {'1':2,'2':1}
                            let actionConditionTaskType = {'3':1,'5':3}
                            let effectiveTypeObj = new Map();//生效时间
                            effectiveTypeObj.set(true,1)
                            effectiveTypeObj.set(false,2)

                            let conditionJudgmentObj = {'2':1,'0':2,'1':3}


                            


                            dataArr.map(item=>{
                                if(Object.keys(triggerConditionTaskType).includes(item.conditionTaskType+'') ){
                                    triggerItemsDataArr.push(item)
                                }else{
                                    actionItemsDataArr.push(item)
                                }
                            })


                            triggerItemsDataArr1 = common.deepClone([...triggerItemsDataArr])

                            for(let i = 0;i<triggerItemsDataArr.length;i++){

                                let item = triggerItemsDataArr[i]

                                triggerItemsDataArr1[i].status = 1
                                triggerItemsDataArr1[i].index = i+1

                                triggerItemsDataArr1[i].id = item.id
                                triggerItemsDataArr1[i].triggerType = triggerConditionTaskType[item.conditionTaskType]
                                triggerItemsDataArr1[i].productTypeId = item.productTypeId? item.productTypeId+'' : null
                                triggerItemsDataArr1[i].productTypeName = item.deviceWordCode || ''
                                triggerItemsDataArr1[i].basicId = null
                                triggerItemsDataArr1[i].keyId = item.sceneData.deviceCommandList?(item.sceneData.deviceCommandList[0].identifier ?item.sceneData.deviceCommandList[0].identifier:item.sceneData.deviceCommandList[0].commandKey+'_'+item.sceneData.deviceCommandList[0].commandKeyType):null 
                                
                                
                                
                                triggerItemsDataArr1[i].keyObj = {}
                                triggerItemsDataArr1[i].dateObj = {}
                                triggerItemsDataArr1[i].conditionJudgment = 0
                                triggerItemsDataArr1[i].formatType =  item.sceneData.deviceCommandList?item.sceneData.deviceCommandList[0].formatType : null
                                triggerItemsDataArr1[i].intType =  item.sceneData.deviceCommandList?conditionJudgmentObj[item.sceneData.deviceCommandList[0].conditionCompareLogic] : 1

                                let valueName = ''

                                if(this.formatNumber.includes( triggerItemsDataArr1[i].formatType)){
                                     valueName = 'intValue'
                                }else if(this.formatEnum.includes( triggerItemsDataArr1[i].formatType)){
                                     valueName = 'enumValue'
                                }else if(this.formatDate.includes( triggerItemsDataArr1[i].formatType)){
                                     valueName = 'timeValue'
                                }else{
                                     valueName = 'objValue'
                                }

                                if((item.formatType==4 || item.formatType==11) && item.sceneData.deviceCommandList && item.sceneData.deviceCommandList[0] && item.sceneData.deviceCommandList[0].wordCode){
                                    let wordCode = item.sceneData.deviceCommandList[0].wordCode
                                    let wordCodeIndex = item.sceneData.deviceCommandList[0].wordCode.indexOf("_")+1
                                    if(wordCode.slice(wordCodeIndex)=='el102lr_color' || wordCode.slice(wordCodeIndex)=='el100lr_color'){
                                        valueName = 'colorValue'
                                    }
                                   
                                }

                                


                                triggerItemsDataArr1[i].intValue =  null
                                triggerItemsDataArr1[i].timeValue =  ''
                                triggerItemsDataArr1[i].colorValue =  ''
                                triggerItemsDataArr1[i].enumValue =  null
                                triggerItemsDataArr1[i].objValue =  null
                               
                                let resval =  item.sceneData.deviceCommandList?(item.sceneData.deviceCommandList[0].commandValue+'' || item.sceneData.deviceCommandList[0].identifierValue+'') : null
                                if(valueName!='intValue'){
                                    triggerItemsDataArr1[i][valueName] = resval
                                }

                                let formatContentTime = null
                                try {
                                    formatContentTime = item.sceneData.deviceCommandList && item.sceneData.deviceCommandList[0].formatContent?JSON.parse(item.sceneData.deviceCommandList[0].formatContent):null
                                } catch (error) {
                                    
                                }
                                // console.log('show valueName',valueName)
                                // console.log('resval',resval)
                                // console.log('formatContentTime',formatContentTime)
                                // console.log('triggerItemsDataArr1[i].formatType',triggerItemsDataArr1[i].formatType)
                                // int32类型，吕伟平台时间
                                // if(valueName=='intValue' && resval &&( resval.includes(':') || resval.includes('-'))){
                                //     triggerItemsDataArr1[i].timeValue = resval
                                // }
                                if((valueName=='intValue' && formatContentTime && formatContentTime[0] && formatContentTime[0].formate )|| valueName=='timeValue'){
                                    // console.log('resval',resval)
                                    // console.log('triggerItemsDataArr1[i].formatType',triggerItemsDataArr1[i].formatType)

                                    // 如果是16进制日期，先转为10进制
                                    if(triggerItemsDataArr1[i].formatType == 12){
                                        resval = parseInt(resval, 16)
                                    }


                                    let intvalTime = resval

                                    triggerItemsDataArr1[i].timeValue = resval;

                                    let formateObj = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss','HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm:ss','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
                                    
                                    let formate = formatContentTime[0].formate
                                    let unit = formatContentTime[0].time

                            
                                    // console.log('item.keyObj.formatContentObj[0]',formatContentTime)
                                    let timeObj = {'1':1/1000,'2':1,'3':60,'4':3600,'0x01':1/1000,'0x02':1,'0x03':60,'0x04':3600}  //ms s m h
                                    
                                    let valOld = resval*timeObj[unit];//全部转换成秒

                                    // console.log('resval',resval)
                                    // console.log('timeObj',timeObj)
                                    // console.log('unit',unit)
                                    // console.log('valOld',valOld)
                                    
                                    let newVal = intvalTime
                                    
                                    if(formate=='HH-MM-SS' || formate=='HH-MM'){
                                        const duration = moment.duration(valOld, 'seconds');
                                        const h = duration.hours();
                                        const m = duration.minutes();
                                        const s = duration.seconds();
                                        newVal = h+':'+ m+':'+s 
                                    } else if(formate=='MM-SS'){
                                        const duration = moment.duration(valOld, 'seconds');
                                        const h = duration.hours();
                                        const m = duration.minutes();
                                        const s = duration.seconds();
                                        // newVal =  h+':'+m+':'+s 
                                        newVal =  m+':'+s 

                                        // console.log('newValMM-SS',newVal)

                                    } else if(formate=='MM-SS-MS'){
                                      // 将秒数转换成毫秒
                                      var ms = valOld * 1000;
                                      
                                      // 获取毫秒数中的毫秒部分
                                      var msPart = ms % 1000;

                                      if(msPart<10){
                                          msPart='00'+msPart
                                      }else if(msPart<100){
                                          msPart='0'+msPart
                                      }
                                      
                                      // 将剩余的毫秒数转换成秒
                                      var secondsPart = (ms - msPart) / 1000;
                                      
                                      // 获取秒数部分
                                      var s = secondsPart % 60;

                                      if(s<10) s='0'+s
                                      
                                      // 将剩余的秒数转换成分钟
                                      var minutesPart = (secondsPart - s) / 60;
                                      
                                      // 获取分钟部分
                                      var m = minutesPart % 60;

                                      if(m<10) m='0'+m
                                      
                                      // 获取小时部分
                                      //   var h = (minutesPart - m) / 60;
                                      newVal = m + ":" + s + "."+msPart;


                                    } else if(formate=='SS-MS'){
                                        // 将秒数转换成毫秒
                                      var ms = valOld * 1000;
                                      
                                      // 获取毫秒数中的毫秒部分
                                      var msPart = ms % 1000;

                                      if(msPart<10){
                                          msPart='00'+msPart
                                      }else if(msPart<100){
                                          msPart='0'+msPart
                                      }
                                      
                                      // 将剩余的毫秒数转换成秒
                                      var secondsPart = (ms - msPart) / 1000;
                                      
                                      // 获取秒数部分
                                      var s = secondsPart % 60;

                                      if(s<10) s='0'+s
                                      
                                      // 获取小时部分
                                      //   var h = (minutesPart - m) / 60;
                                      newVal = s + "."+msPart;

                                    }
                                //    console.log('newValnewValnewValnewVal',newVal)
                                    triggerItemsDataArr1[i].timeValue = newVal
                                }
                   
                                if(valueName=='enumValue' && this.formatHex.includes(triggerItemsDataArr1[i].formatType)){
                                    triggerItemsDataArr1[i][valueName] = '0x'+ triggerItemsDataArr1[i][valueName]
                                }

                                if(valueName=='colorValue'){
                                    triggerItemsDataArr1[i][valueName] = '#'+resval
                                }

                               

                             
 
                                
                                triggerItemsDataArr1[i].showAddition =  (item.sceneData.additionalList && item.sceneData.additionalList.length)?false:true
                                triggerItemsDataArr1[i].additionType =  1
                                triggerItemsDataArr1[i].effectiveType = triggerItemsDataArr1[i].showAddition==false? effectiveTypeObj.get(item.sceneData.additionalList[0].alwaysTakeEffect):( item.sceneData.hasOwnProperty('alwaysTakeEffect')? effectiveTypeObj.get(item.sceneData.alwaysTakeEffect):1)
                                triggerItemsDataArr1[i].weatherType = item.weatherType || 1
                                
                                
                                triggerItemsDataArr1[i].repeatType =  triggerItemsDataArr1[i].showAddition==false ?  item.sceneData.additionalList[0].sceneTimeMode+1 :( item.sceneData.hasOwnProperty('sceneTimeMode')? item.sceneData.sceneTimeMode+1:1)
                                triggerItemsDataArr1[i].specialTime = triggerItemsDataArr1[i].triggerType==2?item.sceneData.startTime : '00:00'
                                triggerItemsDataArr1[i].partTime = (triggerItemsDataArr1[i].effectiveType==2 &&  triggerItemsDataArr1[i].showAddition==false)?[item.sceneData.additionalList[0].startTime,item.sceneData.additionalList[0].endTime] :['07:00','08:00']



                                triggerItemsDataArr1[i].weekVal =triggerItemsDataArr1[i].repeatType ==2?(triggerItemsDataArr1[i].showAddition==false? item.sceneData.additionalList[0].weekDays.split(',').map(Number) :(item.sceneData.hasOwnProperty('weekDays')?item.sceneData.weekDays.split(',').map(Number):[])):[]
                                triggerItemsDataArr1[i].monthVal =triggerItemsDataArr1[i].repeatType ==3?(triggerItemsDataArr1[i].showAddition==false?item.sceneData.additionalList[0].monthDay:(item.sceneData.hasOwnProperty('monthDay')?item.sceneData.monthDay:1)):1
                                triggerItemsDataArr1[i].yearVal =triggerItemsDataArr1[i].repeatType ==4?(triggerItemsDataArr1[i].showAddition==false?item.sceneData.additionalList[0].yearDay.split('-').map(Number):(item.sceneData.hasOwnProperty('yearDay')?item.sceneData.yearDay.split('-').map(Number):[]))  :  []
                                triggerItemsDataArr1[i].dateVal =triggerItemsDataArr1[i].repeatType ==5?(triggerItemsDataArr1[i].showAddition==false?item.sceneData.additionalList[0].onceDay:(item.sceneData.hasOwnProperty('onceDay')?item.sceneData.onceDay:'' )):  ''

                              
                            }
                            this.formData.triggerItems = common.deepClone([...triggerItemsDataArr1])

                            for(let i = 0;i<this.formData.triggerItems.length;i++){
                                  this.$nextTick(()=>{
                                    if(this.$refs['productTypeIdSelectTrigger'+i][0] && this.formData.triggerItems[i].productTypeId){
                                        // 赋值之后，basicId会自动赋值
                                        this.$refs['productTypeIdSelectTrigger'+i][0].setDefVal({id:this.formData.triggerItems[i].productTypeId,productType:this.formData.triggerItems[i].productTypeName})
                                       
                                    }
                                })

                            }


                            actionItemsDataArr1 = common.deepClone([...actionItemsDataArr])

                            for(let i = 0;i<actionItemsDataArr1.length;i++){
                                let item = actionItemsDataArr1[i]

                                actionItemsDataArr1[i].status = 1
                                actionItemsDataArr1[i].index = i+1

                                actionItemsDataArr1[i].id = item.id
                                actionItemsDataArr1[i].actionType = actionConditionTaskType[item.conditionTaskType]
                                actionItemsDataArr1[i].productTypeId = item.productTypeId? item.productTypeId+'' : null
                                actionItemsDataArr1[i].productTypeName = item.deviceWordCode || ''
                                actionItemsDataArr1[i].basicId =  null
                                actionItemsDataArr1[i].keyId = item.sceneData.deviceCommandList?(item.sceneData.deviceCommandList[0].identifier ?item.sceneData.deviceCommandList[0].identifier:item.sceneData.deviceCommandList[0].commandKey+'_'+item.sceneData.deviceCommandList[0].commandKeyType):null 
                                
                                
                                actionItemsDataArr1[i].keyObj = {}
                                actionItemsDataArr1[i].dateObj = {}
                                actionItemsDataArr1[i].conditionJudgment = 0
                                actionItemsDataArr1[i].formatType = item.sceneData.deviceCommandList?item.sceneData.deviceCommandList[0].formatType : null
                                actionItemsDataArr1[i].intType =   item.sceneData.deviceCommandList?conditionJudgmentObj[item.sceneData.deviceCommandList[0].conditionCompareLogic] : 1


                                let valueName = ''
                                if(this.formatNumber.includes( actionItemsDataArr1[i].formatType)){
                                     valueName = 'intValue'
                                }else if(this.formatEnum.includes( actionItemsDataArr1[i].formatType)){
                                     valueName = 'enumValue'
                                }else if(this.formatDate.includes( actionItemsDataArr1[i].formatType)){
                                     valueName = 'timeValue'
                                }else{
                                     valueName = 'objValue'
                                }

                                if((item.formatType==4 || item.formatType==11) && item.sceneData.deviceCommandList && item.sceneData.deviceCommandList[0] && item.sceneData.deviceCommandList[0].wordCode){
                                    let wordCode = item.sceneData.deviceCommandList[0].wordCode
                                    let wordCodeIndex = item.sceneData.deviceCommandList[0].wordCode.indexOf("_")+1
                                    if(wordCode.slice(wordCodeIndex)=='el102lr_color' || wordCode.slice(wordCodeIndex)=='el100lr_color'){
                                        valueName = 'colorValue'
                                    }
                                   
                                }

                                // console.log('valueName',valueName)

                                actionItemsDataArr1[i].intValue =  null
                                actionItemsDataArr1[i].timeValue =  ''
                                actionItemsDataArr1[i].colorValue =  ''
                                actionItemsDataArr1[i].enumValue =  null
                                actionItemsDataArr1[i].objValue =  null

                                let resval =  item.sceneData.deviceCommandList?(item.sceneData.deviceCommandList[0].commandValue+'' || item.sceneData.deviceCommandList[0].identifierValue+'') : null

                                
                                
                                
                                if(valueName!='intValue'){
                                    actionItemsDataArr1[i][valueName] =  resval
                                }
                                //  // int32类型，吕伟平台时间
                                //  if(valueName=='intValue' && resval &&( resval.includes(':') || resval.includes('-'))){
                                //     actionItemsDataArr1[i].timeValue = resval
                                // }

                                let formatContentTime = null
                                try {
                                    formatContentTime = item.sceneData.deviceCommandList && item.sceneData.deviceCommandList[0].formatContent?JSON.parse(item.sceneData.deviceCommandList[0].formatContent):null
                                } catch (error) {
                                    
                                }
                                // console.log('show valueName',valueName)
                                // console.log('resval',resval)
                                // console.log('formatContentTime',formatContentTime)
                               
                                if((valueName=='intValue' && formatContentTime && formatContentTime[0] && formatContentTime[0].formate )|| valueName=='timeValue'){

                                    // 如果是16进制日期，先转为10进制
                                    if(actionItemsDataArr1[i].formatType == 12){
                                        resval = parseInt(resval, 16)
                                    }

                                    let intvalTime = resval

                                    actionItemsDataArr1[i].timeValue = resval;

                                    let formateObj = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss','HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm:ss','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
                                    
                                    let formate = formatContentTime[0].formate

                                    let unit = formatContentTime[0].time
                                    
                                    // console.log('item.keyObj.formatContentObj[0]',item.keyObj.formatContentObj[0])
                                    let timeObj = {'1':1/1000,'2':1,'3':60,'4':3600,'0x01':1/1000,'0x02':1,'0x03':60,'0x04':3600}  //ms s m h
                                    
                                    let valOld = resval*timeObj[unit];//全部转换成秒

                                    // console.log('show valOld',valOld)
                                    
                                    let newVal = intvalTime
                                    
                                    if(formate=='HH-MM-SS' || formate=='HH-MM'){
                                        const duration = moment.duration(valOld, 'seconds');
                                        const h = duration.hours();
                                        const m = duration.minutes();
                                        const s = duration.seconds();
                                        newVal = h+':'+ m+':'+s 
                                    } else if(formate=='MM-SS'){
                                        const duration = moment.duration(valOld, 'seconds');
                                        const h = duration.hours();
                                        const m = duration.minutes();
                                        const s = duration.seconds();
                                        // newVal =  h+':'+m+':'+s 
                                        newVal =  m+':'+s 

                                    } else if(formate=='MM-SS-MS'){
                                      // 将秒数转换成毫秒
                                      var ms = valOld * 1000;
                                      
                                      // 获取毫秒数中的毫秒部分
                                      var msPart = ms % 1000;

                                      if(msPart<10){
                                          msPart='00'+msPart
                                      }else if(msPart<100){
                                          msPart='0'+msPart
                                      }
                                      
                                      // 将剩余的毫秒数转换成秒
                                      var secondsPart = (ms - msPart) / 1000;
                                      
                                      // 获取秒数部分
                                      var s = secondsPart % 60;

                                      if(s<10) s='0'+s
                                      
                                      // 将剩余的秒数转换成分钟
                                      var minutesPart = (secondsPart - s) / 60;
                                      
                                      // 获取分钟部分
                                      var m = minutesPart % 60;

                                      if(m<10) m='0'+m
                                      
                                      // 获取小时部分
                                      //   var h = (minutesPart - m) / 60;
                                      newVal = m + ":" + s + "."+msPart;


                                    } else if(formate=='SS-MS'){
                                        // 将秒数转换成毫秒
                                      var ms = valOld * 1000;
                                      
                                      // 获取毫秒数中的毫秒部分
                                      var msPart = ms % 1000;

                                      if(msPart<10){
                                          msPart='00'+msPart
                                      }else if(msPart<100){
                                          msPart='0'+msPart
                                      }
                                      
                                      // 将剩余的毫秒数转换成秒
                                      var secondsPart = (ms - msPart) / 1000;
                                      
                                      // 获取秒数部分
                                      var s = secondsPart % 60;

                                      if(s<10) s='0'+s
                                      
                                      // 获取小时部分
                                      //   var h = (minutesPart - m) / 60;
                                      newVal = s + "."+msPart;

                                    }
                                //    console.log('newValnewValnewValnewVal',newVal)
                                   actionItemsDataArr1[i].timeValue = newVal
                                }
                            
                                if(valueName=='enumValue' && this.formatHex.includes(actionItemsDataArr1[i].formatType)){
                                    actionItemsDataArr1[i][valueName] = '0x'+ actionItemsDataArr1[i][valueName]
                                }

                                if(valueName=='colorValue'){
                                    actionItemsDataArr1[i][valueName] = '#'+resval
                                }

                                // console.log('actionItemsDataArr1[i]',actionItemsDataArr1[i])
                                // actionItemsDataArr1[i].selected =  item.whetherCheckedTask || false
                                actionItemsDataArr1[i].selected = true
                                actionItemsDataArr1[i].systemFunctionType =  1
                                actionItemsDataArr1[i].messageReminderType =  1
                                actionItemsDataArr1[i].notificationVal =   item.sceneData.pushMessage?item.sceneData.pushMessage.message:''
                                actionItemsDataArr1[i].delaySeconds =   item.sceneData.delaySeconds || 0
                            }


                            this.formData.actionItems = common.deepClone([...actionItemsDataArr1])


                            for(let i = 0;i<this.formData.actionItems.length;i++){
                                this.$nextTick(()=>{
                                    if(this.$refs['productTypeIdSelectAction'+i][0] && this.formData.actionItems[i].productTypeId){
                                        this.$refs['productTypeIdSelectAction'+i][0].setDefVal({id:this.formData.actionItems[i].productTypeId,productType:this.formData.actionItems[i].productTypeName})
                                    }
                             
                                })


                            }



                            this.triggerIndex = this.formData.triggerItems.length
                            this.actionIndex = this.formData.actionItems.length

                            if(this.triggerIndex>1){
                                this['enumTriggerDelDisabled'] = false
                            }
                            if(this.actionIndex>1){
                                this['enumActionDelDisabled'] = false
                            }

                            
                            console.log('this.formData.triggerItems',this.formData.triggerItems)
                            console.log('this.formData.actionItems',this.formData.actionItems)
                        }
                      
                    } else { //关闭弹框后要做的处理
                        this.resetForm();//重置表单
                        for(let i = 0;i<this.formData.triggerItems.length;i++){
                            this.$nextTick(()=>{
                                if(this.$refs['productTypeIdSelectTrigger'+i][0] && this.formData.triggerItems[i].productTypeId){
                                    // 赋值之后，basicId会自动赋值
                                    this.$refs['productTypeIdSelectTrigger'+i][0].clearVal()
                                }

                              
                                if(this.$refs['keyIdSelectTrigger'+i][0] && this.formData.triggerItems[i].productTypeId){
                                    this.$refs['keyIdSelectTrigger'+i][0].clearVal()
                                }
                            })
                        }
                        for(let i = 0;i<this.formData.actionItems.length;i++){
                            this.$nextTick(()=>{
                                if(this.$refs['productTypeIdSelectAction'+i][0] && this.formData.actionItems[i].productTypeId){
                                    this.$refs['productTypeIdSelectAction'+i][0].clearVal()
                                }
                                if(this.$refs['keyIdSelectAction'+i][0] && this.formData.actionItems[i].productTypeId){
                                    this.$refs['keyIdSelectAction'+i][0].clearVal()
                                }
                            })
                        }
                        
                        this.$refs.upLogoImg.clearImg()
                        
                    }
                },
                
            },
            methods: {
                triggerItemsInputCheck(rule, value, callback){
                      let field = rule.field || rule.fullField
                      let index = Number(field.substr(field.indexOf('.') + 1, 1))
                      let item = this.formData.triggerItems[index]

                    if(this.formatStr.includes(item.formatType)){
                  
                        if(item.keyObj.keyNameText == "色彩" || item.keyObj.keyNameText == "Color" || item.keyObj.keyNameObj.wordId=="120840" || item.keyObj.keyNameObj.LanguageKey=="el100lr_color" || item.keyObj.keyNameObj.LanguageKey=="el102lr_color"){
                           let color =item.objValue
                            // 移除字符串中的所有空格
                           color = color.replace(/\s+/g, '');
                           // 正则表达式匹配16进制颜色代码，以#开始，后跟6个16进制数字
                          //    const regex = /^#([0-9a-fA-F]{6})$/;
                           const regex = /^[0-9A-Fa-f]{6}$/;
                           // 测试字符串是否匹配正则表达式
                           const isValid = regex.test(color);
                           // 如果不匹配，返回false或进行错误处理
                           if (!isValid) {
                              callback(new Error(this.$t('seceneManage.tip.hexColor')));
                           }else{
                            callback();
                           }
                        }

                    }else{
                        callback();
                    }

                },
                actionItemsInputCheck(rule, value, callback){
                      let field = rule.field || rule.fullField
                      let index = Number(field.substr(field.indexOf('.') + 1, 1))
                      let item = this.formData.actionItems[index]

                    if(this.formatStr.includes(item.formatType)){
                        if((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987'))){
                           let color =item.objValue
                            // 移除字符串中的所有空格
                           color = color.replace(/\s+/g, '');
                           // 正则表达式匹配16进制颜色代码，以#开始，后跟6个16进制数字
                          //    const regex = /^#([0-9a-fA-F]{6})$/;
                        //    const regex = /^[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/;
                           const regex = /^[0-9A-Fa-f]{6}$/;
                           // 测试字符串是否匹配正则表达式
                           const isValid = regex.test(color);
                           // 如果不匹配，返回false或进行错误处理
                           if (!isValid) {
                              callback(new Error(this.$t('seceneManage.tip.hexColor')));
                           }else{
                            callback();
                           }
                        }

                    }else{
                        callback();
                    }

                },
                triggerItemsValidateCheckMax(rule, value, callback){// 设备属性是日期型，时间部分涉及到最大值，最小值，需要在两者中间取值
                    //   console.log('value',value)
                    //   console.log('rule',rule)
                      let field = rule.field || rule.fullField
                      let index = Number(field.substr(field.indexOf('.') + 1, 1))
                      let timeArr = []
                      
                      let noVerf = false
                      if(value.includes('-') && value.length==10){// 年月日，不验证时间
                         noVerf = true
                      }else if(value.includes('-') && value.length>10){// 年月日，验证时间
                        timeArr = (value.split(' '))[1].split(':')
                      }else{
                        timeArr = value? value.split(':'):[]
                      }


                      let item = this.formData.triggerItems[index]

                      let minstr = item.dateObj.minTimestamp
                      let maxstr = item.dateObj.maxTimestamp

                      let formate = ''
                      let unit = ''
                      try {
                        formate = item.keyObj.formatContentObj[0].formate
                        unit = item.keyObj.formatContentObj[0].time
                      } catch (error) {
                        
                      }


                      
                      let timestr = 0

                    //   if(timeArr.length==3){//时分秒
                    //     timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(timeArr[2])*1000)
                    //   }else if(timeArr.length==2){//时分
                    //     timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000
                    //   }

                      if(timeArr.length==3){//时分秒
                            if(timeArr[2].includes('.')){
                                let s = (timeArr[2].split('.'))[0]
                                let ms = (timeArr[2].split('.'))[1]
                                timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(s)*1000) + Number(ms)
                            }else{
                               timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(timeArr[2])*1000)
                            }
                      }else if(timeArr.length==2){
                         if(formate == "MM-SS"){
                            timestr = Number(timeArr[0])*60*1000 + (Number(timeArr[1])*1000)
                          }
                          if(formate == "MM-SS-MS"){
                            if(timeArr[1].includes('.')){
                                let s = (timeArr[1].split('.'))[0]
                                let ms = (timeArr[1].split('.'))[1]
                                timestr = Number(timeArr[0])*60*1000+(Number(s)*1000) + Number(ms)
                            }else{
                                timestr = Number(timeArr[0])*60*1000 + (Number(timeArr[1])*1000)
                            }
                        }
                      }




                    

                    //    required: (item.triggerType==1 && item.basicId && item.keyId && formatDate.includes(item.formatType) && item.status===1)?true:false
                      if(item.triggerType==1 && item.basicId && item.keyId && this.formatDate.includes(item.formatType) && item.status===1){
                         if((!value || !timeArr.length || (timestr>maxstr || timestr<minstr)) && !noVerf){
                            console.log("????")
                            callback(new Error(this.$t('seceneManage.tip.timeRange')));
                         }else{
                            // console.log('成功111')
                            callback();
                         }
                      }else{
                          callback();
                      }
                       

                },
                actionItemsValidateCheckMax(rule, value, callback){// 设备属性是日期型，时间部分涉及到最大值，最小值，需要在两者中间取值
                    //   console.log('value',value)
                    //   console.log('rule',rule)
                      let field = rule.field || rule.fullField
                      let index = Number(field.substr(field.indexOf('.') + 1, 1))
                      let timeArr = []
                      
                      let noVerf = false
                      if(value.includes('-') && value.length==10){// 年月日，不验证时间
                         noVerf = true
                      }else if(value.includes('-') && value.length>10){// 年月日，验证时间
                        timeArr = (value.split(' '))[1].split(':')
                      }else{
                        timeArr = value? value.split(':'):[]
                      }


                      
                     



                      let item = this.formData.actionItems[index]

                      let minstr = item.dateObj.minTimestamp
                      let maxstr = item.dateObj.maxTimestamp

                      let formate = ''
                      let unit = ''
                      try {
                        formate = item.keyObj.formatContentObj[0].formate
                        unit = item.keyObj.formatContentObj[0].time
                      } catch (error) {
                        
                      }


                      let timestr = 0

                      console.log('timeArrtimeArr',timeArr)
                      
                      if(timeArr.length==3){//时分秒
                        if(timeArr[2].includes('.')){
                            let s = (timeArr[2].split('.'))[0]
                            let ms = (timeArr[2].split('.'))[1]
                            timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(s)*1000) + Number(ms)
                        }else{
                           timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(timeArr[2])*1000)
                        }
                      }else if(timeArr.length==2){//时分,没有用到，时间选择器给出的都是时分秒
                      
                        if(formate == "MM-SS"){
                            timestr = Number(timeArr[0])*60*1000 + (Number(timeArr[1])*1000)
                        }

                        if(formate == "MM-SS-MS"){
                            if(timeArr[1].includes('.')){
                                let s = (timeArr[1].split('.'))[0]
                                let ms = (timeArr[1].split('.'))[1]
                                timestr = Number(timeArr[0])*60*1000+(Number(s)*1000) + Number(ms)
                            }else{
                                timestr = Number(timeArr[0])*60*1000 + (Number(timeArr[1])*1000)
                            }
                        }

                        
                        // timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000
                      }

                    //    required: (item.triggerType==1 && item.basicId && item.keyId && formatDate.includes(item.formatType) && item.status===1)?true:false
                      if(item.actionType==3 && item.basicId && item.keyId && this.formatDate.includes(item.formatType) && item.status===1){
                         if((!value || !timeArr.length || (timestr>maxstr || timestr<minstr)) && !noVerf){
                            console.log("????")
                            callback(new Error(this.$t('seceneManage.tip.timeRange')));
                         }else{
                            // console.log('成功111')
                            callback();
                         }
                      }else{
                          callback();
                      }
                       

                },
                actionItemsValidateCheckMax1(rule, value, callback){// 设备属性是日期型，时间部分涉及到最大值，最小值，需要在两者中间取值
                      console.log('value',value)
                    //   console.log('rule',rule)
                      let field = rule.field || rule.fullField
                      let index = Number(field.substr(field.indexOf('.') + 1, 1))
                      let timeArr = []
                      let valOld = ''
                      let noVerf = false
                      if(value.includes('-') && value.length==10){// 年月日，不验证时间
                         noVerf = true
                      }else if(value.includes('-') && value.length>10){// 年月日，验证时间
                        timeArr = (value.split(' '))[1].split(':')
                        valOld = (value.split(' '))[1]
                      }else{
                        timeArr = value? value.split(':'):[]
                        valOld = value? value:''
                      }


                      let item = this.formData.actionItems[index]

                      let minstr = item.dateObj.minTimestamp  //毫秒
                      let maxstr = item.dateObj.maxTimestamp  //毫秒

                      let formate = ''
                      let unit = ''
                      try {
                        formate = item.keyObj.formatContentObj[0].formate
                        unit = item.keyObj.formatContentObj[0].time
                      } catch (error) {
                        
                      }




                      let timeObj = {'1':1000,'2':1,'3':1/60,'4':1/3600,'0x01':1000,'0x02':1,'0x03':1/60,'0x04':1/3600}  //ms s m h
                      let formateObj = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss','HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm:ss','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
                  
                      console.log('valOld',valOld)
                      console.log('formate',formate)
                      console.log('unit',unit)
                      
                      let newVal = ''
                      if(formate=='HH-MM-SS' || formate=='HH-MM' || formate=='MM-SS'){
                          newVal = moment.duration(valOld).as('seconds')* 1000
                    
                      } else if(formate=='MM-SS-MS' || formate=='SS-MS'){
                          
                        console.log('valOld.length',valOld.length)
                          if(valOld.length==12){

                              let hh = valOld.substr(0, 2);
                              let mm = valOld.substr(3, 2);
                              let ss = valOld.substr(6, 2);
                              let ms = valOld.substr(9, 3);
                              newVal = (hh*3600+mm*60+ss*1+ms/1000)*1000
                          }else if(valOld.length==9){
                              let hh = 0;
                              let mm = valOld.substr(0, 2);
                              let ss = valOld.substr(3, 2);
                              let ms = valOld.substr(6, 3);
                              newVal = (hh*3600+mm*60+ss*1+ms/1000)*1000
                          }
                        
                          console.log('valOld',valOld)
                        

                          console.log('newVal',newVal)
                      }



                    //   let timestr = 0

                    // if(timeArr.length==3 && item.keyObj&& item.keyObj.formatContentObj && item.keyObj.formatContentObj[0] && item.keyObj.formatContentObj[0].formate=='HH-MM-SS'){//时分秒
                    //   timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000+(Number(timeArr[2])*1000)
                    // }else if(timeArr.length==2){//时分
                    //   timestr = Number(timeArr[0])*60*60*1000+Number(timeArr[1])*60*1000
                    // }

                      console.log('item',item)
                      console.log('timeArrtimeArr',timeArr)
                    //   console.log('value',value)
                      console.log('maxstr',maxstr)
                      console.log('minstr',minstr)
                      console.log('newVal',newVal)

                    //    required: (item.triggerType==1 && item.basicId && item.keyId && formatDate.includes(item.formatType) && item.status===1)?true:false
                      if(item.actionType==3 && item.basicId && item.keyId && this.formatDate.includes(item.formatType) && item.status===1){
                         if((!value || !timeArr.length || (newVal>maxstr || newVal<minstr)) && !noVerf){
                            console.log('????')
                            callback(new Error(this.$t('seceneManage.tip.timeRange')));
                         }else{
                            // console.log('成功111')
                            callback();
                         }
                      }else{
                          callback();
                      }
                       

                },
                delAdditionalCondition(index){//删除附加条件
                    // console.log('删除附加条件',index)
                    this.formData.triggerItems[index-1].showAddition = true

                    if(this.formData.triggerItems[index-1].additionType==1){

                        let keyArr = ["effectiveType","weatherType","partTime","repeatType","additionType","weekVal","monthVal","yearVal","dateVal"]
    
                        keyArr.map(item=>{
    
                            for(let key in this.triggerInitdata){
                                if(item==key){
                                    this.formData['triggerItems'][index-1][key] = this.triggerInitdata[key]
                                    break
                                }
      
                            }
                        })
                    }

                    this.$forceUpdate()
                },
                getDays() {//获取当前时间，月日联动
                    const isLeapYear = (year) => ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
                    const now = new Date();
                    const year = now.getFullYear();
                    const daysInFebruary = isLeapYear(year) ? 29 : 28;

                    let daysInMonth = {'1':31,'2':daysInFebruary,'3':31,'4':30,'5':31,'6':30,'7':31,'8':31,'9':30,'10':31,'11':30,'12':31}

                    this.currentMonth = (now.getMonth()) +1 <10?'0'+((now.getMonth()) +1):(now.getMonth()) +1
                    this.currentDay = now.getDate()<10?'0'+(now.getDate()):now.getDate()
                    this.currentYear = now.getFullYear()
                    let arr = []
                    for (let [key, value] of Object.entries(daysInMonth)) {
                        arr.push({
                            value:key*1,
                            label:key*1,
                            children: Array.from({ length: value}, (_, index) => {
                                return {
                                    value:index+1,
                                    label:index+1,
                                }
                            })
                        })
                    }

                    this.monthsAndDaysArr = arr

                
                 },
                async  getWordList(pageId){//获取多语言列表
                    let params={
                            page:1,
                            limit:100000,
                            pageId
                        }
                    let  result = await this.axios.post(this.config.urlArray.pagesLangDictionaryList,params)
                    if(result){
                        this.wordList = result.data.data.dealersList

                        return result.data.data.dealersList
                    }

                    return []
                    
                },
                selectOpenChange(status,propertyName){//下拉框展开或收起时触发
                    let len = (this.formData['triggerItems'].filter(item=>item.status==1)).length
                //    if(propertyName=='triggerType' && len>=2){//条件类型下拉框，判断status为1的里面是不是已经有了手动点击，有了的话，把这项改为不可选状态
                //      let hasFlag = false
                //      this.formData['triggerItems'].map(item=>{
                //         if(item.status==1 && item.triggerType==3){
                //             hasFlag = true
                //         }
                //      })
                //      if(hasFlag){
                //          this.$set(this.selectObj.triggerTypeList[2], 'disabled',true);
                //      }else{
                //         this.$set(this.selectObj.triggerTypeList[2], 'disabled',false);
                //      }
                //    }
                },
                clearSelectVal(index,type,propertyName){//某个属性置空


                    // console.log('clearSelectVal propertyName',propertyName);

                    (this.formData[type][index-1])[propertyName] = null;

                    let typeObj1 = {'triggerItems':'triggerType','actionItems':'actionType'}
                    let typeObj2 = {'triggerItems':'triggerInitdata','actionItems':'actionInitdata'}
                    let typeObj3 = {'triggerItems':'keyIdSelectTrigger','actionItems':'keyIdSelectAction'};


                    if(propertyName=='productTypeId'){//清空基础型号
                        for(let key in this[typeObj2[type]]){
                            if(key !=typeObj1[type] && key !='productTypeId' && key !='index' && key !='status'){
                                this.formData[type][index-1][key] = this[typeObj2[type]][key]
                            }
                        }

                        if(this.$refs[typeObj3[type]+(index-1)][0]){
                            this.$refs[typeObj3[type]+(index-1)][0].clearVal()
                        }

                    }


                    if(propertyName=='keyId'){//清空属性值
                        for(let key in  this[typeObj2[type]]){
                            if(key !=typeObj1[type] && key !='productTypeId' && key !='productTypeName'&& key !='wordList' && key !='basicId' && key !='keyId' && key !='index' && key !='status'){
                                this.formData[type][index-1][key] =  this[typeObj2[type]][key]
                            }
                        }

                    }






                    
                },

                async setSelectValPage(selItem,index,propertyName,type='triggerItems'){//select组件，有限个选项时触发on-select事件

                    let selecrOneList = ['triggerType','intType','repeatType','monthVal','effectiveType','weatherType','actionType','enumValue','additionType','systemFunctionType','messageReminderType']
                   
                    let formatTypeArr1 = [1,7,14,15,16];//所有数值型，结果乘以放大倍数Multiple
                    let formatTypeArr2 = [7]; //hex number 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x
                    let formatTypeArr3 = [14];//hex snumber 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x,注意开头规则，负数

                    if(!selItem) { // 带清除功能的组件，清空时

                        // console.log('indexindexindex',index)
                        this.clearSelectVal(index,type,propertyName)
                        return
                    }

                   
                    // console.log('propertyNamepropertyNamepropertyName',propertyName)
                    // console.log('indexindexindex',index)
                    let changeVal = false

                    if(selecrOneList.includes(propertyName)){

                        if((this.formData[type][index-1])[propertyName] != selItem.value){
                            this.$set(this.formData[type][index-1], propertyName, selItem.value);
                            changeVal = true
                        }

                    }else{
                        if((this.formData[type][index-1])[propertyName] != selItem.id){
                            this.$set(this.formData[type][index-1], propertyName, selItem.id+'');
                            changeVal = true
                        }
                    }

                //    console.log('changeValchangeVal',changeVal)

                    // console.log(this.formData[type])



                    let propertyObj1 = {'actionType':'Action','triggerType':'Trigger'};
                    let propertyObj2 = {'actionType':'action','triggerType':'trigger'};
                    let propertyObj3 = {'actionType':3,'triggerType':1};


                    if(propertyObj1.hasOwnProperty(propertyName) && changeVal){//任务类型下拉框切换选项时，后面所有重置
                         

                        //任务类型是设备属性时
                        if(selItem.value==propertyObj3[propertyName] || (propertyName=='triggerType' && selItem.value==3)){
                            this.$refs['productTypeIdSelect'+propertyObj1[propertyName]+(index-1)][0].getData()

                            if(this.$refs['productTypeIdSelect'+propertyObj1[propertyName]+(index-1)][0]){
                                this.$refs['productTypeIdSelect'+propertyObj1[propertyName]+(index-1)][0].clearVal()
                            }
                        
                        }else{
                           
                           if(this.$refs['productTypeIdSelect'+propertyObj1[propertyName]+(index-1)][0]){
                                this.$refs['productTypeIdSelect'+propertyObj1[propertyName]+(index-1)][0].clearVal()
                           }
                        
                           if(this.$refs['keyIdSelect'+propertyObj1[propertyName]+(index-1)][0]){
                                this.$refs['keyIdSelect'+propertyObj1[propertyName]+(index-1)][0].clearVal()
                           }
                        
                        }

                       

                        
                        for(let key in this[propertyObj2[propertyName]+'Initdata']){
                            if(key != propertyName && key !='index' && key !='status'){
                                this.formData[propertyObj2[propertyName]+'Items'][index-1][key] = this[propertyObj2[propertyName]+'Initdata'][key]
                            }
                        }
                    
                    }


                    
                    let typeObj1 = {'triggerItems':'Trigger','actionItems':'Action'}
                    let typeObj2 = {'triggerItems':'trigger','actionItems':'action'}


                    if(propertyName=='productTypeId' && typeObj1.hasOwnProperty(type) && (changeVal || this.type==2)){ // 切换产品型号的时候
                        (this.formData[type][index-1])['basicId'] = selItem.basicTypeId;
                        (this.formData[type][index-1])['productTypeName'] = selItem.productType;
                         let res =  await this.getWordList(selItem.pageId);
                         (this.formData[type][index-1])['wordList'] = common.deepClone([...res])

                        if(changeVal){
                            this.$refs['keyIdSelect'+typeObj1[type]+(index-1)][0].getData(this.formData[type][index-1]['basicId'])

                            for(let key in this[typeObj2[type]+'Initdata']){
                                
                                if(key !=typeObj2[type]+'Type' && key !='productTypeId'  && key !='productTypeName' && key !='basicId' && key !='wordList'  && key !='keyId' && key !='index' && key !='status'){
                                    this.formData[typeObj2[type]+'Items'][index-1][key] = this[typeObj2[type]+'Initdata'][key]
                                }
                            }
                            
                            if(this.$refs['keyIdSelect'+typeObj1[type]+(index-1)][0]){
                                this.$refs['keyIdSelect'+typeObj1[type]+(index-1)][0].clearVal()
                            }

                        }
                        if(this.type==2 && changeVal==false){
                        
                            this.$refs['keyIdSelect'+typeObj1[type]+(index-1)][0].setDefVal({id: this.formData[typeObj2[type]+'Items'][index-1]['keyId'],basicTypeId:selItem.basicTypeId})
                        }

                    }
            
                

            


                    if(propertyName=='keyId' && typeObj1.hasOwnProperty(type) && (changeVal || this.type==2)){//选择设备属性的时候

                        this.formData[typeObj2[type]+'Items'][index-1]['conditionJudgment'] = selItem.conditionJudgment;
                        
                        this.formData[typeObj2[type]+'Items'][index-1]['formatType'] = selItem.formatType;
                        this.formData[typeObj2[type]+'Items'][index-1]['keyObj'] = selItem;

                        console.log("this.formData['triggerItems'][index-1]",this.formData[typeObj2[type]+'Items'][index-1])
                       
                        if(this.formatDate.indexOf(selItem.formatType)>-1 ){//日期型
                            let min = Number(selItem.formatContentObj[0].min || 0)
                            let max =  Number(selItem.formatContentObj[0].max || 0)
                            let unit = selItem.formatContentObj[0].time
                            let timeObj = {'1':1,'2':1000,'3':60000,'4':3600000,'0x01':1,'0x02':1000,'0x03':60000,'0x04':3600000}
                   
                            let h24 = Array.from({length:24},(_,i)=>i)
                            let m60 = Array.from({length:60},(_,i)=>i)

                            let  hms_max = (moment.utc(max * timeObj[unit]).format('HH:mm:ss')).split(':')
                            let  hms_min = (moment.utc(min * timeObj[unit]).format('HH:mm:ss')).split(':')



                            this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].placeholder = moment.utc(min * timeObj[unit]).format('HH:mm:ss')+' ~ '+moment.utc(max * timeObj[unit]).format('HH:mm:ss')
                            this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].minTimestamp =min * timeObj[unit]
                            this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].maxTimestamp = max * timeObj[unit]
                           
                            
                            if(selItem.formatContentObj[0].formate=='HH-MM-SS' || selItem.formatContentObj[0].formate=='YYYY-MM-DD HH-MM-SS'){
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledHours = [...h24.slice(0,hms_min[0]*1),...h24.slice(hms_max[0]*1+1,24)]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledMinutes = []
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledSeconds = []
                            }else if(selItem.formatContentObj[0].formate=='HH-MM'){

                               
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledHours = [...h24.slice(0,hms_min[0]*1),...h24.slice(hms_max[0]*1+1,24)]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledMinutes = []
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledSeconds = [...m60]

                            }else if(selItem.formatContentObj[0].formate=='MM-SS' || selItem.formatContentObj[0].formate=='MM-SS-MS'){
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledHours = [...h24]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledMinutes = [...m60.slice(0,hms_min[1]*1),...m60.slice(hms_max[1]*1+1,60)]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledSeconds = []
                            }else if(selItem.formatContentObj[0].formate=='SS-MS'){
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledHours = [...h24]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledMinutes = [...m60]
                                this.formData[typeObj2[type]+'Items'][index-1]['dateObj'].disabledSeconds = [...m60.slice(0,hms_min[2]*1),...m60.slice(hms_max[2]*1+1,60)]
                            }

                        }

                        if(this.formatEnum.includes(selItem.formatType*1)){//类似数组类型
                            // console.log('this.wordListthis.wordList',this.wordList)

                            this.formData[typeObj2[type]+'Items'][index-1]['keyObj'].formatContentObj.map(item=>{


                                for(let i =0;i< (this.formData[type][index-1])['wordList'].length;i++){
    
                                    if(item.pageId_wordCode==this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].pageId+'_'+this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].wordCode){
                                       
                                        item.simpleChinese = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].simpleChinese
                                        item.englishText = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].englishText

                                       break;
                                    }
                                }

                                if(item.hasOwnProperty('Unit pageId_wordCode')){

                                    for(let i =0;i< (this.formData[type][index-1])['wordList'].length;i++){
        
                                        if(item['Unit pageId_wordCode']==this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].pageId+'_'+this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].wordCode){
                                           
                                            item.simpleChineseUnit = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].simpleChinese
                                            item.englishTextUnit = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].englishText
                                           break;
                                        }
                                    }
                                }

                                if(!item.simpleChinese|| !this.formData[typeObj2[type]+'Items'][index-1]['wordList'].length){
                                    item.simpleChinese = item['CN'] || item['Name-CN']
                                    item.englishText = item['EN'] || item['Name-EN']
                                }

                                if(item['Unit pageId_wordCode'] &&  (!item.simpleChineseUnit  || !this.formData[typeObj2[type]+'Items'][index-1]['wordList'].length)){
                                    item.simpleChineseUnit = item['Unit Name-CN']
                                    item.englishTextUnit = item['Unit Name-EN']
                                }

                                item.nameText = this.local=='zh-CN'?item.simpleChinese:item.englishText
                                item.unitText = this.local=='zh-CN'?(item.simpleChineseUnit || ''):(item.englishTextUnit || '')

                                return item
                            })

                            if(changeVal){

                                this.formData[typeObj2[type]+'Items'][index-1]['enumValue'] = null
                            }

                        }

                        if(this.formatNumber.includes(selItem.formatType*1)){//数字类型
                            this.formData[typeObj2[type]+'Items'][index-1]['keyObj'].formatContentObj.map(item=>{
                            
                                if(item.hasOwnProperty('Unit-CN')){
                                
                                    for(let i =0;i< (this.formData[type][index-1])['wordList'].length;i++){
                                
                                        if(item['pageId_wordCode']==this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].pageId+'_'+this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].wordCode){
                                           
                                            item.simpleChineseUnit = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].simpleChinese
                                            item.englishTextUnit = this.formData[typeObj2[type]+'Items'][index-1]['wordList'][i].englishText
                                           break;
                                        }
                                    }
                                }
                                if(item['Unit pageId_wordCode'] &&  (!item.simpleChineseUnit  || !this.formData[typeObj2[type]+'Items'][index-1]['wordList'].length)){
                                    item.simpleChineseUnit = item['Unit Name-CN']
                                    item.englishTextUnit = item['Unit Name-EN']
                                }
                                item.unitText = this.local=='zh-CN'?(item.simpleChineseUnit || ''):(item.englishTextUnit || '')
                                return item
                            })



                        }
                        // console.log('this.wordListthis.wordList',this.formData['triggerItems'][index-1]['wordList'])
                        // console.log('this.wordListthis.wordList', (this.formData[type][index-1])['wordList'])

                        if(this.type==2 && changeVal==false){


                            if(this.formatNumber.includes(this.formData[typeObj2[type]+'Items'][index-1].formatType)){
                                
                                let commandValueRes =  this.formData[typeObj2[type]+'Items'][index-1].sceneData.deviceCommandList[0].commandValue+'' || this.formData[typeObj2[type]+'Items'][index-1].sceneData.deviceCommandList[0].identifierValue+''
                

                                 if(formatTypeArr2.includes(selItem.formatType)){
                                     commandValueRes = parseInt(commandValueRes, 16)
                                 }
                                 
                                 if(formatTypeArr3.includes(selItem.formatType)){
                                     
                                     commandValueRes = this.hexToDec(commandValueRes,selItem.hexValueBytes||1)
                                 }
    
                                 if(formatTypeArr1.includes(selItem.formatType)){
                                    let hasMultiple = !isNaN(parseFloat(selItem.formatContentObj[0].Multiple))&& isFinite(selItem.formatContentObj[0].Multiple)
                                     commandValueRes = (selItem.formatContentObj[0].hasOwnProperty('Multiple') && hasMultiple && selItem.formatContentObj[0].Multiple ) ? commandValueRes/selItem.formatContentObj[0].Multiple:commandValueRes
                                 }
                                 try {
                                    
                                     this.formData[typeObj2[type]+'Items'][index-1]['intValue'] =Number(commandValueRes) 
                                 } catch (error) {
                                    this.formData[typeObj2[type]+'Items'][index-1]['intValue'] =commandValueRes
                                 }
                            }
    
                        }

                          this.$forceUpdate()
                    }

                    
                  

                    
          
                },

                setSelectColor(selItem,index,propertyName,type='triggerItems'){
                    this.$set(this.formData[type][index-1], propertyName, selItem);
                    console.log('this.formData[type][index-1], propertyName, selItem',this.formData[type][index-1], propertyName, selItem)
                    
                },
                setSelectChange(selItem,index,propertyName,type='triggerItems'){//select组件，有限个选项时触发on-change事件 或者input的on-change
                    // console.log('indexindex',index);
            
                    // this.formData[type][index-1][propertyName] = selItem

                    this.$set(this.formData[type][index-1], propertyName, selItem);


                    // console.log('this.formData[type][index-1], propertyName, selItem',this.formData[type][index-1], propertyName, selItem)

                    // console.log('this.formData[type]1111',this.formData[type])

                    if(selItem===null && propertyName=='delaySeconds' ){
                        this.formData[type][index-1][propertyName] = 0
                    }

                    if(propertyName=='specialTime'){
                        
                        if(this.formData[type][index-1]['dateVal']==this.currentYear+'-'+this.currentMonth+'-'+this.currentDay){
                            let timeArr = selItem.split(':')
                            if(timeArr[0]*1>((new Date().getHours()))){
                                this.disabledMinutes = []
                            }else{
                                this.disabledMinutes = [...Array.from({length:new Date().getMinutes()},(_,i)=>i+1),0]
                            }
                        }
                    }
             

                    this.$forceUpdate()

                    // console.log('selItem',selItem)
                    // console.log('propertyName',propertyName)
                    // console.log('this.formData[type][index-1]',this.formData[type][index-1]['weekVal'])
                    // console.log('this.formData.triggerItems[index-1][propertyName]',typeof this.formData[type][index-1][propertyName])
                    console.log('this.formData[type]222',this.formData[type])
                },
                setDateChange(selItem,item,propertyName,type='triggerItems'){//日期组件，触发on-select事件
                    // let selecrTwoList = ['weekVal']
                    let index = item.index
                    this.formData[type][index-1][propertyName] = selItem + ''

                    // 00:00:01
                    
                    // 分秒毫秒 00:00.000
                    if((item.keyObj && item.keyObj.formatContentObj && item.keyObj.formatContentObj[0] )&& item.keyObj.formatContentObj[0].formate == 'MM-SS-MS'){
                        
                        this.formData[type][index-1][propertyName] = selItem.includes(".")?selItem.slice(0, -3).concat('000') :selItem.concat('.000')
                    }

                    // 秒-毫秒  00.000
                    if((item.keyObj && item.keyObj.formatContentObj && item.keyObj.formatContentObj[0] )&& item.keyObj.formatContentObj[0].formate == 'SS-MS'){
                        this.formData[type][index-1][propertyName] = selItem.includes(".")?selItem.slice(0, -3).concat('000') :selItem.concat('.000')
                    }
                    
                    console.log('timeValue',selItem)
                    // console.log('item',item)
                   
                    // console.log('this.formData',this.formData[type][index-1][propertyName])



                    if(propertyName=='dateVal'){//指定当前日期，更改specialTime值
                        const now = new Date(Date.now() + 1000*60) ;
                        this.formData[type][index-1].specialTime = now.getHours()+':'+now.getMinutes()
                        if(selItem==this.currentYear+'-'+this.currentMonth+'-'+this.currentDay){

                            this.disabledHours = [...Array.from({length:now.getHours()-1},(_,i)=>i+1),0]
                            this.disabledMinutes = [...Array.from({length:now.getMinutes()},(_,i)=>i+1),0]
                        }else{
                            this.disabledHours = []
                            this.disabledMinutes = []
                        }
                    }
                    
                },
            
              
                handleAddItem (type) {//新增条件或者动作
                    
                    this[type+'Index']++

                    let obj = {...this[type+'Initdata'],index: this[type+'Index']}
                    
              
                    this.formData[type+'Items'].push(obj)
                    
                    let arr = this.formData[type+'Items'].filter(item=>item.status)
                    let len = this.formData[type+'Items'].length-1

                    let capitalizeType =  type.charAt(0).toUpperCase() + type.slice(1)

                    if(arr.length>1){
                        this['enum'+capitalizeType+'DelDisabled'] = false
                    }

           
                    
                    if(type=='trigger'){
                        this.$nextTick(()=>{
                            this.$refs['productTypeIdSelectTrigger'+len][0].getData()
                        })
                    }
    
                },
                handleRemove (index,type) {//删除条件或者动作

                    console.log('删除条件')
                    this.formData[type+'Items'][index].status = 0;

                    if(type=='trigger'){//条件类型下拉框，判断status为1的里面是不是已经有了手动点击，有了的话，把这项改为不可选状态
                        //  let hasFlag = false
                        //  this.formData['triggerItems'].map(item=>{
                        //     if(item.status==1 && item.triggerType==3){
                        //         hasFlag = true
                        //     }
                        //  })
                        //  if(hasFlag){
                        //      this.$set(this.selectObj.triggerTypeList[2], 'disabled',true);
                        //  }else{
                        //     this.$set(this.selectObj.triggerTypeList[2], 'disabled',false);
                        //  }
       
                    }

                    let capitalizeType =  type.charAt(0).toUpperCase() + type.slice(1)


                    this.$nextTick(()=>{
                         if(this.$refs['productTypeIdSelect'+capitalizeType+index][0]){
                             this.$refs['productTypeIdSelect'+capitalizeType+index][0].clearVal()
                         }
                         if(this.$refs['keyIdSelect'+capitalizeType+index][0]){
                             this.$refs['keyIdSelect'+capitalizeType+index][0].clearVal()
                         }
                     })

                    
                    let arr = this.formData[type+'Items'].filter(item=>item.status)

                    if(arr.length<2){
                        this['enum'+capitalizeType+'DelDisabled'] = true
                    }

                    this.$forceUpdate()
                },
                setThumbUrlthumb(item) {//图片上传
                  console.log("url", item);
                  let url = item.data
                  this.formData.bgImage = url
                },
                removeThumbUrl(index){//删除图片
                   this.formData.bgImage = '';
                },
                decToHex(decNumber, byteLength) {// 将10进制数转换为指定字节长度的Buffer  转化成16进制，根据hexValueBytes的值，补齐长度，不要0x
                  var buffer = Buffer.alloc(byteLength);
                  buffer.writeUIntBE(decNumber, 0, byteLength);
                  
                  // 将Buffer转换为16进制字符串
                  return buffer.toString('hex');
                },
                decimalToBinaryAndHex(decimal, byteLength) {// 将10进制转换为指定字节长度的2进制字符串
                    let binaryString = (Math.abs(decimal)).toString(2);
                    binaryString = binaryString.padStart(byteLength * 8, '0'); // 填充到指定字节长度
                 
                    // 修改首个字符为1（如果是正数，则不变）
                    if (decimal<0) {
                        binaryString = '1' + binaryString.slice(1);
                    }
                    const hexString = parseInt(binaryString, 2);
                 
                    return this.decToHex(hexString,byteLength)
                },
                hexToDec(hexStr, byteLength) {// 将16进制数转换为10进制，带符号
                    var num = parseInt(hexStr, 16);
                    var binary = num.toString(2);
                    while (binary.length < byteLength * 8) {
                      binary = '0' + binary;
                    }

                    let flag = 1

                    if(binary[0]==1){//负数
                        flag = -1
                        binary = '0' + binary.slice(1);
                    }
                    binary = parseInt(binary, 2)

                    return binary*flag;
                },
                
                subData(name) {//提交表单
                    console.log('this.formData.triggerItems',this.formData.triggerItems)
                    console.log('this.formData.actionItems',this.formData.actionItems)

                    
                    this.$refs[name].validate((valid) => {
                        console.log(77777)
                        
                        if (valid) {

                            let params = {
                                dealerId:this.selectId,
                                templateName:this.formData.templateName,
                                bgImage:this.formData.bgImage,
                                sceneTemplateContents:[
        
                                ]
                            }
        
                            if(this.type==2){
                                params.id = this.editFormData.id
                            }

        
        
                            // showAction 为false的时候有附加条件
                            let effectiveTypeObj = {'1':true,'2':false} ;//生效时间
                            let triggerTaskType = {'1':2,'2':1}
                            let actionTaskType = {'1':3,'3':5}
                            let conditionJudgmentObj = {'1':2,'2':0,'3':1}

                            
                 

                    
                            let formatTypeArr1 = [1,7,14,15,16];//所有数值型，结果乘以放大倍数Multiple
                            let formatTypeArr2 = [7]; //hex number 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x
                            let formatTypeArr3 = [14];//hex snumber 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x,注意开头规则，负数
        
        
                            this.formData.triggerItems.map((item,index)=>{
                             
                                if(item.status==1){
                                    let paramsItem = {
                                        id:item.id || '',
                                        sceneTemplateId:params.id || '',
                                        conditionTaskType:triggerTaskType[item.triggerType],
                                        deviceWordCode:item.productTypeName || '',
                                        productTypeId:item.productTypeId || '',
                                        basicTypeId:item.basicId || '',
                                        whetherCheckedTask:true,
                                        // sortNumber:item.sortNumber || 1,
                                        sceneData:{
                                           
                                        }
                                    }
                                    if(this.type==1){
                                        delete paramsItem.id
                                        delete paramsItem.sceneTemplateId
                                    }

        
                                    if(item.triggerType==1){//设备属性触发
        
                                        paramsItem.sceneData = {
                                            "additionalList":[],
                                            "deviceCommandList":[],
                                        }
        
                                        let valueName = ''
                                        if(this.formatNumber.includes(item.keyObj.formatType)){
                                             valueName = 'intValue'
                                        }else if(this.formatEnum.includes(item.keyObj.formatType)){
                                             valueName = 'enumValue'
                                        }else if(this.formatDate.includes(item.keyObj.formatType)){
                                             valueName = 'timeValue'
                                        }else{
                                             valueName = 'objValue'
                                        }

                                        if((item.formatType==4 ||item.formatType==11)  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))){
                                            valueName = 'colorValue'
                                        }

                                        // console.log('valueName',valueName)


                                       
        
        
                                        if(!item.showAddition){
                                            paramsItem.sceneData.additionalList.push(
                                                {
                                                 "additionType": 1,
		                                         "alwaysTakeEffect": effectiveTypeObj[item.effectiveType],
		                                         "sceneTimeMode": item.repeatType-1, //0-每天执行,1-每周执行,2-每月执行,3-每年执行,4-指定日期执行     *********** ******
                                                 "weekDays" :item.repeatType-1==1? item.weekVal.join(','):'',//多个中间用逗号隔开，1-7表示周日到周六 ***********
                                                 "monthDay" : item.repeatType-1==2?item.monthVal:'',//几号，取值范围1-31 ***********
                                                 "yearDay" : item.repeatType-1==3?item.yearVal.join('-'):'',//应该是月份-日 ***********
                                                 "onceDay" : item.repeatType-1==4?item.dateVal:'',//指定一次定时模式的年月日 ***********
                                                 "startTime": !effectiveTypeObj[item.effectiveType]?item.partTime[0]:'',
                                                 "endTime":  !effectiveTypeObj[item.effectiveType]?item.partTime[1]:'',
                                                 }
                                            )
                                        }

                                        let commandValueRes = item[valueName] || ''

                                        // console.log('commandValueRescommandValueRes',commandValueRes)


                                        if(valueName=='intValue'){

                                            // let formatTypeArr1 = [1,7,14,15,16];//所有数值型，结果乘以放大倍数Multiple
                                            // let formatTypeArr2 = [7]; //hex number 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x
                                            // let formatTypeArr3 = [14];//hex snumber 转化成16进制，根据hexValueBytes的值，补齐长度，不要0x,注意开头规则，负数

                                            if(formatTypeArr1.includes(item.keyObj.formatType)){
                                                let hasMultiple = !isNaN(parseFloat(item.keyObj.formatContentObj[0].Multiple))&& isFinite(item.keyObj.formatContentObj[0].Multiple)
                                                commandValueRes = item.keyObj.formatContentObj[0].hasOwnProperty('Multiple') && hasMultiple ? item[valueName]*item.keyObj.formatContentObj[0].Multiple:item[valueName]
                                            }
    
                                            if(formatTypeArr2.includes(item.keyObj.formatType)){
                                                commandValueRes = this.decToHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                                // console.log('commandValueRescommandValueRes1',commandValueRes)
                                            }
    
                                            if(formatTypeArr3.includes(item.keyObj.formatType)){
                                                
                                                commandValueRes = this.decimalToBinaryAndHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                                // console.log('commandValueRescommandValueRes2',commandValueRes)
                                            }
                                        }

                                        if(valueName=='enumValue' && this.formatHex.includes(item.keyObj.formatType)){

                                            if(commandValueRes.indexOf('0x')>-1 || commandValueRes.indexOf('0X')>-1){
                                                commandValueRes = commandValueRes.slice(2)
                                            }
                                        }

                                        if(valueName=='timeValue'){
                                            let unit = item.keyObj.formatContentObj[0].time

                                            let formate = item.keyObj.formatContentObj[0].formate

                                            // console.log('item.keyObj.formatContentObj[0]',item.keyObj.formatContentObj[0])
                                            let valOld = item[valueName]
                                            let timeObj = {'1':1000,'2':1,'3':1/60,'4':1/3600,'0x01':1000,'0x02':1,'0x03':1/60,'0x04':1/3600}  //ms s m h
                                            let formateObj = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss','HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm:ss','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
                                     
                                            console.log('valOld',valOld)
                                          
                                            let newVal = ''

                                            if(formate=='HH-MM-SS' || formate=='HH-MM'){
                                                newVal = moment.duration(valOld).as('seconds')* timeObj[unit]
                                            } else if(formate=='MM-SS'){
                                                if(valOld.split(":").length==2){
                                                    newVal = moment.duration('00:'+ valOld).as('seconds')* timeObj[unit]
                                                }else if(valOld.split(":").length==3){
                                                    newVal = moment.duration( valOld).as('seconds')* timeObj[unit]
                                                }
                                            } else if(formate=='MM-SS-MS'){
                                                // console.log('valOld.length',valOld.length)
                                                if(valOld.length=='9'){

                                                    let mm = valOld.substr(0, 2);
                                                    let ss = valOld.substr(3, 2);
                                                    let ms = valOld.substr(6, 3);
                                                    newVal = (mm*60+ss*1+ms/1000)* timeObj[unit]

                                                    console.log('newValmss',newVal)
                                                }



                                            } else if(formate=='SS-MS'){
                                                let ss = time.substr(0, 2);
                                                let ms = time.substr(3, 3); 
                                                newVal = (ss+ms/1000)* timeObj[unit]
                                            }


                                            //十进制
                                            commandValueRes = newVal


                                            // 十六进制 hexdatetime ,不用带0x

                                            if(item.keyObj.formatType == 12){
                                                commandValueRes = this.decToHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                            }

                                            console.log('newVal',newVal)
                                        
                                        }

                                        // 色彩，去掉#
                                        if(valueName=='colorValue'){
                                            if(commandValueRes.startsWith("#")){
                                                commandValueRes = commandValueRes.slice(1)
                                            }
                                        }

                                        

                                        console.log('commandValueRes',commandValueRes)


                                        paramsItem.sceneData.deviceCommandList.push({
                                            'commandKey':item.keyObj.keyId || '',
                                            'commandKeyType':item.keyObj.keyType || '',
                                            'commandValue':item.keyId?commandValueRes:'',
                                            'identifier':item.keyObj.identifier || '',
                                            'identifierValue':item.keyObj.identifier?commandValueRes:'',
                                            'conditionCompareLogic':conditionJudgmentObj.hasOwnProperty(item.intType)? conditionJudgmentObj[item.intType]: 2,
                                            'formatContent':item.keyObj.formatContent,
                                            'formatType':item.keyObj.formatType==-1?16:item.keyObj.formatType,
                                            // 'productTypeId':item.productTypeId,
                                            'uiCode':item.keyObj.conUiCode,
                                            'wordCode': item.keyObj.keyName_pageId_wordCode
                                        })

                               
                                        
                                    }else if(item.triggerType==2){//定时触发
                                        paramsItem.sceneData = {
                                             "additionType": 1,
		                                     "alwaysTakeEffect": effectiveTypeObj[item.effectiveType],
		                                     "sceneTimeMode": item.repeatType-1, //0-每天执行,1-每周执行,2-每月执行,3-每年执行,4-指定日期执行     *********** ******
                                             "weekDays" :item.repeatType-1==1? item.weekVal.join(','):'',//多个中间用逗号隔开，1-7表示周日到周六 ***********
                                             "monthDay" : item.repeatType-1==2?item.monthVal:'',//几号，取值范围1-31 ***********
                                             "yearDay" : item.repeatType-1==3?item.yearVal.join('-'):'',//应该是月份-日 ***********
                                             "onceDay" : item.repeatType-1==4?item.dateVal:'',//指定一次定时模式的年月日 ***********
                                             "startTime": item.specialTime,
                                        }
                                    }
                                    params.sceneTemplateContents.push(paramsItem)
        
                                }
                            })
        
        
        
                            this.formData.actionItems.map((item,index)=>{
                             
                                if(item.status==1){
        
                                    let paramsItem = {
                                        id:item.id || '',
                                        sceneTemplateId:params.id || '',
                                        conditionTaskType:actionTaskType[item.actionType],
                                        deviceWordCode:item.productTypeName || '',
                                        productTypeId:item.productTypeId || '',
                                        basicTypeId:item.basicId || '',
                                        whetherCheckedTask:true,
                                        // sortNumber:item.sortNumber || 1,
                                        sceneData:{
                                           
                                        }
                                    }
        
                                    if(this.type==1){
                                        delete paramsItem.id
                                        delete paramsItem.sceneTemplateId
                                    }
        
        
                                    if(item.actionType==3){//设备属性触发
        
                                         paramsItem.sceneData = {
                                             "delaySeconds":item.delaySeconds || 0,
                                             "deviceCommandList":[],
                                         }
            
                                         let valueName = ''
                                         if(this.formatNumber.includes(item.keyObj.formatType)){
                                              valueName = 'intValue'
                                         }else if(this.formatEnum.includes(item.keyObj.formatType)){
                                              valueName = 'enumValue'
                                         }else if(this.formatDate.includes(item.keyObj.formatType)){
                                              valueName = 'timeValue'
                                         }else{
                                              valueName = 'objValue'
                                         }

                                        if((item.formatType==4 ||item.formatType==11)  && ((item.keyObj &&(item.keyObj.keyNameText=='色彩' || item.keyObj.keyNameText=='Color') ) || (item.keyObj.keyNameObj && (item.keyObj.keyNameObj.LanguageKey=='el100lr_color'|| item.keyObj.keyNameObj.LanguageKey=='el1002lr_color'|| item.keyObj.keyNameObj.wordId=='31987')))){
                                            valueName = 'colorValue'
                                        }


                                         

                                         let commandValueRes = item[valueName] || ''

                                         if(valueName=='intValue'){

                                             if(formatTypeArr1.includes(item.keyObj.formatType)){
                                                 let hasMultiple = !isNaN(parseFloat(item.keyObj.formatContentObj[0].Multiple))&& isFinite(item.keyObj.formatContentObj[0].Multiple)
                                                 commandValueRes = item.keyObj.formatContentObj[0].hasOwnProperty('Multiple') && hasMultiple? item[valueName]*item.keyObj.formatContentObj[0].Multiple:item[valueName]
                                             }
     
                                             if(formatTypeArr2.includes(item.keyObj.formatType)){
                                                 commandValueRes = this.decToHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                             }
     
                                             if(formatTypeArr3.includes(item.keyObj.formatType)){
                                                 
                                                 commandValueRes = this.decimalToBinaryAndHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                             }
                                         }




                                        if(valueName=='enumValue' && this.formatHex.includes(item.keyObj.formatType)){

                                            if(commandValueRes.indexOf('0x')>-1 || commandValueRes.indexOf('0X')>-1){
                                                commandValueRes = commandValueRes.slice(2)
                                            }
                                        }
                                        
                                        //时间类型，转成对应单位的数值
                                        if(valueName=='timeValue'){
                                            let unit = item.keyObj.formatContentObj[0].time

                                            let formate = item.keyObj.formatContentObj[0].formate

                                            console.log('item.keyObj.formatContentObj[0]',item.keyObj.formatContentObj[0])
                                            let valOld = item[valueName]
                                            let timeObj = {'1':1000,'2':1,'3':1/60,'4':1/3600,'0x01':1000,'0x02':1,'0x03':1/60,'0x04':1/3600}  //ms s m h
                                            let formateObj = {'YYYY-MM-DD':'yyyy-MM-dd','YYYY-MM-DD HH-MM-SS':'yyyy-MM-dd HH:mm:ss','HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm:ss','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'}  //ms s m h
                                     
                                            console.log('valOld',valOld)
                                          
                                            let newVal = ''

                                            if(formate=='HH-MM-SS' || formate=='HH-MM'){
                                                newVal = moment.duration(valOld).as('seconds')* timeObj[unit]
                                            } else if(formate=='MM-SS'){
                                                if(valOld.split(":").length==2){
                                                    newVal = moment.duration('00:'+ valOld).as('seconds')* timeObj[unit]
                                                }else if(valOld.split(":").length==3){
                                                    newVal = moment.duration( valOld).as('seconds')* timeObj[unit]
                                                }
                                            } else if(formate=='MM-SS-MS'){
                                                let mm = time.substr(0, 2);
                                                let ss = time.substr(3, 2);
                                                let ms = time.substr(6, 3);
                                                newVal = (mm*60+ss*1+ms/1000)* timeObj[unit]
                                            } else if(formate=='SS-MS'){
                                                let ss = time.substr(0, 2);
                                                let ms = time.substr(3, 3); 
                                                newVal = (ss+ms/1000)* timeObj[unit]
                                            }

                                            //十进制
                                            commandValueRes = newVal


                                            // 十六进制 hexdatetime ,不用带0x

                                            if(item.keyObj.formatType == 12){
                                                commandValueRes = this.decToHex(commandValueRes,item.keyObj.hexValueBytes||1)
                                            }

                                            console.log('newVal',newVal)
                                        }

                                        // 色彩，去掉#
                                        if(valueName=='colorValue'){
                                            if(commandValueRes.startsWith("#")){
                                                commandValueRes = commandValueRes.slice(1)
                                            }
                                        }
            
                                         paramsItem.sceneData.deviceCommandList.push({
                                             'commandKey':item.keyObj.keyId || '',
                                             'commandKeyType':item.keyObj.keyType || '',
                                             'commandValue':item.keyId?commandValueRes:'',
                                             'identifier':item.keyObj.identifier||'',
                                             'identifierValue':item.keyObj.identifier?commandValueRes:'',
                                             'conditionCompareLogic':conditionJudgmentObj.hasOwnProperty(item.intType)? conditionJudgmentObj[item.intType]: 2,
                                             'formatContent':item.keyObj.formatContent,
                                             'formatType':item.keyObj.formatType==-1?16:item.keyObj.formatType,
                                             'uiCode':item.keyObj.taskUiCode ,//item.conUiCode
                                             'wordCode': item.keyObj.keyName_pageId_wordCode
                                         })
                                     
                                    }else if(item.actionType==1){//消息提醒
                                        paramsItem.sceneData = {
                                             "sysType":1,
                                             "delaySeconds":item.delaySeconds || 0,
                                             "pushMessage":{
                                                 "message":item.notificationVal,
                                                 "wordCode":'wordCode'
                                             }
                                         }
                                     }
                                     params.sceneTemplateContents.push(paramsItem)
            
                                }
                            })
        
        
                            console.log('paramsparamsparams',params)
                            
                            
    
                            
                            
    
                            let url = this.type == 2? this.config.urlArray.modifySceneTemplate:this.config.urlArray.createSceneTemplate
                  
                            
                            let paramsObj = {...params,dealerId:this.selectId}
                           
                            
                            // return
    
                            this.disabled = true;
    
                            console.log('params',params)
     
                            this.axios.post(url, paramsObj).then((result) => {
                                
                                common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                    this.cancel();//重置表单
                                    this.fn()
                                },()=>{
                                    this.disabled = false;
                                })
                                
                                
                            }).catch((err) => {
                                // common.msg('error',this.$t('failed'),()=>{this.disabled = false;})
                                this.disabled = false;
                            });
                            
                        }
                    })
                },
                cancel() {//对话框关闭
                    this.resetForm();//重置表单
                    this.$emit('update:showModel',false);
                    this.$emit('update:offModel',true);
                },
                resetForm() {//重置表单
                    this.$refs.formData.resetFields();//重置表单
                    this.disabled = false;//恢复提交按钮为激活状态
                    this.hasUpload = []
                    // this.formData.triggerItems = common.deepClone( [{...this.triggerInitdata}])
                    // this.formData.actionItems = common.deepClone( [{...this.actionInitdata}])

                    // Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                    this.formData = {//表单数据
                        templateName:'',
                        bgImage:'',//基础型号对应的上传的图片编号
                        triggerItems: [
                           {
                               triggerType:1,//触发条件
                               productTypeId:null,//产品型号id
                               productTypeName:'',//产品型号名称
                               wordList:[],
                               basicId:null, //基础型号id
                               keyId:null,//设备属性id
                               keyObj:{},//设备属性对应的对象
                               conditionJudgment:0,//基础功能对应的符号
                               formatType:null,//格式
                               intType:1,//符号是 = 还是<>=
                               intValue:null,//number类型的值
                               timeValue:'',//时间类型的值
                               enumValue:null,//数组类型的值
                               objValue:null,//其他类型的值
                               colorValue:'',//色彩的值
                               dateObj:{},// 值为时间类型时计算不能选的时分秒列表
                               showAddition:true,//是否显示附加条件那些item,为false的时候有附件条件
                               additionType:1,//附加条件类型
                               repeatType:1,//重复次数类型
                               specialTime:'00:00',//触发条件是定时触发时，选的时间
                               weekVal:[],//重复次数类型时是周循环时选的值
                               monthVal:1,//重复次数类型时是月循环时选的值
                               yearVal:[],//重复次数类型时是年循环时选的值
                               dateVal:'',//重复次数类型时是指定日期循环时选的值
                               effectiveType:1,//生效时间类型，默认是全天生效 
                               weatherType:1,//天气，默认是全部 
                               partTime:['07:00','08:00'],//生效时间类型为部分时间段时，时间段是值
                               sortNumber:1,
                               index: 1,
                               status: 1
                           }
                        ],
                        actionItems:[
                            {
                                actionType:1,//执行任务类型
                                systemFunctionType:1,//选择系统功能后对应的列表
                                messageReminderType:1,//选择消息提醒后对应的列表
                                notificationVal:'',//发送消息对应的消息内容
                                delaySeconds:0,//延迟时间，单位s
                                productTypeId:null,//产品型号id
                                productTypeName:'',//产品型号名称
                                wordList:[],
                                basicId:null, //基础型号id
                                keyId:null,//设备属性id
                                keyObj:{},//设备属性对应的对象
                                conditionJudgment:0,//基础功能对应的符号
                                formatType:null,//格式
                                intType:1,//符号是 = 还是<>=
                                intValue:null,//number类型的值
                                timeValue:'',//时间类型的值
                                enumValue:null,//数组类型的值
                                objValue:null,//其他类型的值
                                colorValue:'',//色彩的值
                                dateObj:{},// 值为时间类型时计算不能选的时分秒列表
                                selected:true, //是否默认选中
                                sortNumber:1,
                                index: 1,
                                status: 1
                            }
                        ],
                    }
                  
                    
                }
            }
        }
    </script>
    
    <style lang='less' scoped>
    .simple-size {
        color: #ccc;
        font-size: 12px;
        height: 20px;
        padding: 0;
        margin: 0;
        margin-left: -120px;
    }
    /deep/ .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;
        .ivu-modal{
            top: 0;
        }
       
    }
    .divinput{
        /deep/ .ivu-form-item-content{
            line-height: normal;
        }
    }
    
    /deep/ .ivu-input-number{
        width: 100% !important;
    }
    .ivu-input-div{
        cursor:pointer,
    
    }
    
    .verAddCon{
        position: relative;
        background: #fff;
        // padding: 20px;
        margin: 42px 26px 30px 26px;

        .title{
            font-size: 20px;
            padding: 4px 0 0px;
        }
        .colseButton{
            position: absolute;
            right: -14px;
            top:-14px
        }
        // .ivu-layout-content{
        //    min-width: 680px !important;
        //    overflow-x: scroll;
        // }
    }
     /deep/ .ivu-form-item-content{
          margin-left: 120px !important;
          flex-grow: 1;
      }
    .logoCon{
      /deep/ .ivu-form-item-content{
          margin-left: 0px !important;
      }
    }
    /deep/ .ivu-form .ivu-form-item-label{
        width: 120px !important;
    }
    
    .editText{
        margin-left:8px;
        font-size:14px;
        color:#2d8cf0;
        cursor:pointer
    }

    .titleMain{
        margin: 20px 0;
    }
    .tip{
        font-size: 12px;
        margin-bottom: 10px;
    }
    .noSet{
        background-color: #F2F5FC;
        text-align: center;
        line-height: 45px;
        height: 45px;
    }
    .addBut{
        display: inline-block;
        height: 44px;
        line-height: 44px;
        color: #4ABAF0;
        cursor: pointer;
    }
    .imgCon {
        /deep/  .ivu-form-item-error-tip{
            margin-left: -120px;
        }
    }
    .moduleItem{
        /deep/ .ivu-form-item-content{
          margin-left: 20px !important;
          margin-top: 10px;
          &:nth-of-type(1){
            margin-left: 0px !important;
          }
       }

       border-bottom: 1px solid #e6e6e6;
       
       padding-right: 10px;

       .delButton{
        position: absolute;
        right: 0;
       }
    }
    .moduleItemNo{
        border-bottom: none;
    }
    </style>
    